/*
	Author: Able Sense Media
	Web: ablesense.com
	Date of creation: 2015/12/23
*/
// Production steps of ECMA-262, Edition 5, 15.4.4.19
// Reference: http://es5.github.io/#x15.4.4.19
if (!Array.prototype.map) {

  Array.prototype.map = function(callback, thisArg) {

    var T, A, k;

    if (this === null) {
      throw new TypeError(' this is null or not defined');
    }

    // 1. Let O be the result of calling ToObject passing the |this|
    //    value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get internal
    //    method of O with the argument "length".
    // 3. Let len be ToUint32(lenValue).
    var len = O.length >>> 0;

    // 4. If IsCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
    if (arguments.length > 1) {
      T = thisArg;
    }

    // 6. Let A be a new array created as if by the expression new Array(len)
    //    where Array is the standard built-in constructor with that name and
    //    len is the value of len.
    A = new Array(len);

    // 7. Let k be 0
    k = 0;

    // 8. Repeat, while k < len
    while (k < len) {

      var kValue, mappedValue;

      // a. Let Pk be ToString(k).
      //   This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty internal
      //    method of O with argument Pk.
      //   This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {

        // i. Let kValue be the result of calling the Get internal
        //    method of O with argument Pk.
        kValue = O[k];

        // ii. Let mappedValue be the result of calling the Call internal
        //     method of callback with T as the this value and argument
        //     list containing kValue, k, and O.
        mappedValue = callback.call(T, kValue, k, O);

        // iii. Call the DefineOwnProperty internal method of A with arguments
        // Pk, Property Descriptor
        // { Value: mappedValue,
        //   Writable: true,
        //   Enumerable: true,
        //   Configurable: true },
        // and false.

        // In browsers that support Object.defineProperty, use the following:
        // Object.defineProperty(A, k, {
        //   value: mappedValue,
        //   writable: true,
        //   enumerable: true,
        //   configurable: true
        // });

        // For best browser support, use the following:
        A[k] = mappedValue;
      }
      // d. Increase k by 1.
      k++;
    }

    // 9. return A
    return A;
  };
}
// Polyfill: Object.keys
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
	Object.keys = (function() {
		'use strict';
		var hasOwnProperty = Object.prototype.hasOwnProperty,
		hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
		dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		],
		dontEnumsLength = dontEnums.length;

		return function(obj) {
			if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
				throw new TypeError('Object.keys called on non-object');
			}

			var result = [], prop, i;

			for (prop in obj) {
				if (hasOwnProperty.call(obj, prop)) {
					result.push(prop);
				}
			}

			if (hasDontEnumBug) {
				for (i = 0; i < dontEnumsLength; i++) {
					if (hasOwnProperty.call(obj, dontEnums[i])) {
						result.push(dontEnums[i]);
					}
				}
			}
			return result;
		};
	}());
}

// if (typeof Raphael !== 'undefined') {
if (typeof Raphael !== 'undefined') {
	var first_Color_Choice,
		imageSourceResult;

	$(document).ready(function() {
		function mapObjectKeys(objectMappedFrom, objectMappedTo, mapCallback, fontFileCallbackParameter, fontFileNumberCallbackParameter) {
			Object.keys(objectMappedFrom).map(function(key, i) {
				var value = objectMappedFrom[key];
				objectMappedTo[key] = value;

				if (Object.keys(objectMappedFrom).length - 1 === i) {
					return mapCallback(fontFileCallbackParameter, fontFileNumberCallbackParameter);
				}
			});
		}

		function fontLoadedCallback(_font) {
			if (_font) {
				window.font = _font;
			}

			var panelsObject = {
				panels: {
					Left_1: {
						path: 'M83.2,96L77.7,70 34.7,70 41,96Z',
						top_Right_X: 77.7,
						top_Left_X: 41,
						bottom_Right_X: 83.2,
						bottom_Left_X: 34.7,
					},
					Left_2: {
						path: 'M132.6,96L130.3,70 85.6,70 89.3,96Z',
						bottom_Right_X: 132.6,
						top_Right_X: 130.3,
						top_Left_X: 85.6,
						bottom_Left_X: 89.3,
					},
					Right_1: {
						path: 'M182.5,96L185.9,70 140,70 139.4,96Z',
						bottom_Right_X: 182.5,
						top_Right_X: 185.9,
						top_Left_X: 140,
						bottom_Left_X: 139.4,
					},
					Right_2: {
						path: 'M229.5,96.2L235.8,70.3 192.9,70 189,96Z',
						bottom_Right_X: 229.5,
						top_Right_X: 235.8,
						top_Left_X: 192.9,
						bottom_Left_X: 189,
					},
				},
			};

			// Removes the original image
			// $('.productImages.productImage--real').remove();

			// if no period character is defined, create one
			if (!font['.']) {
				font['.'] = "M0,0 L300,0 300,300 0,300z";
			}

			if (typeof tracking !== 'undefined') {
				panelsObject.panels.Left_2.top_Right_X += tracking/2;
				panelsObject.panels.Left_2.bottom_Right_X += tracking/2;
				panelsObject.panels.Right_1.top_Left_X -= tracking/2;
				panelsObject.panels.Right_1.bottom_Left_X -= tracking/2;
			}


			// This is a self contained function
			// it's input is different for each font and is
			// taken from the " panel_Hor_Adjustment " variable which is located in each
			// hockey_team_name_font.js file ( such as calgary_flames_font.js )

			function adjustPanels() {
				var inputKeys = Object.keys(panelsObject.panels);

				for (var i = 0, l = inputKeys.length; l > i; i++) {
					var nextObject = panelsObject.panels[inputKeys[i]],
						inputKeys2 = Object.keys(nextObject);

					for (var i2 = 0, l2 = inputKeys2.length; l2 > i2; i2++) {
						if (inputKeys2[i2] === 'path') {
							nextObject[inputKeys2[i2]] = Raphael.transformPath(nextObject[inputKeys2[i2]], 't'+panel_Hor_Adjustment+', 0');

						} else {
							nextObject[inputKeys2[i2]] = nextObject[inputKeys2[i2]] + panel_Hor_Adjustment;

						}

					}
				}
			}
			adjustPanels();

			function hasLowerCase(str) {
				return (/[a-z]/.test(str));
			}

			function createCharacterObject() {
				// character array doesn't
				var i,
					character_Order_Object = {},
					input_Value = getInputValue(),
					input_Value_Length = input_Value.length;

				character_Order_Object.character_Width_Total = 0;
				character_Order_Object.total = input_Value_Length;
				character_Order_Object.widths = {};
				character_Order_Object.array = [];

				for (i = 0; input_Value_Length > i; i++) {
					var character = input_Value[i],
						current_Width = Raphael.pathBBox(font[character]).width;

					current_Width += tracking || 0;

					if (character === "'") {
						current_Width += 2;
					}

					if (character === '.') {
						current_Width += 3.5;
					}

					if (hasLowerCase(character)) {
						current_Width += 2;
					}

					if (character === ' ' || character === '-') {
						// current_Width -= 1;
					}

					var widthModified = current_Width + outlines.characters.width/2;

					character_Order_Object.widths[character] = widthModified;
					character_Order_Object.character_Width_Total += widthModified;
					character_Order_Object[i] = character;
					character_Order_Object.array.push(character);
				}

				return character_Order_Object;
			}

			// constants go here
			var state = {
				tolerance: 2.1,
				zero_Approx: 0.001,
				svg: {
					height: 370,
				},
				panels: {
					width: 42,
				},
			};

			function slice_Ends(total_Width, i) {
				// console.log('slice_Ends(total_Width:', 'i:',i, ')');

				var first_Character = characterObject[(0 + i)],
					last_Character = characterObject[(characterObject.total - 1 - i)],
					first_Width = characterObject.widths[first_Character],
					last_Width = characterObject.widths[last_Character];

				// console.log(
				// 	'first_Character: ', first_Character,
				// 	'last_Character: ', last_Character
				// );


				// this was a safety check for words that are too long
				// with no implimentation of what to do if the overflow happens
				// instead we have a max char count of 12
				// if (state.panels.total.right.outer < state.panels.width &&
				// 	state.panels.total.left.outer < state.panels.width) {

					total_Width -= (first_Width + last_Width);

					state.panels.total.left.outer += first_Width;
					state.panels.total.right.outer += last_Width;

					characterObject.array.shift();
					characterObject.array.pop();
					state.placement.left.outer.push(first_Character);
					state.placement.right.outer.unshift(last_Character);

					return total_Width;
				// } else {
					// the edge case is something like www w w w w www,
					// where an even split is not possible
					// because the total width will become too great
					// console.log(
					// 	'function slice_Ends() returned false',
					// 	'total_Width: ',
					// 	total_Width,
					// 	'i: ',
					// 	i
					// );
				// 	return false;
				// }
			}

			function drawCharacters() {
				var total_Width = characterObject.character_Width_Total,
					split_Ends_I = 0;

				state.panels.total = {
					left: {
						outer: 0,
						inner: 0,
					},
					right: {
						outer: 0,
						inner: 0,
					},
				};

				state.placement = {
					left: {
						outer: [],
						inner: [],
					},
					right: {
						outer: [],
						inner: [],
					},
				};

				// console.log('getInputValue:', getInputValue());
				while (total_Width > state.panels.width * 2) {
					total_Width = slice_Ends(total_Width, split_Ends_I);
					split_Ends_I++;
				}


				checkCenter(total_Width, split_Ends_I);

				getTransformStrings();

				var all_Panels = [];
				all_Panels = all_Panels.concat(state.placement.left.outer);
				// console.log(
				// 	'state.placement.left.outer:',
				// 	state.placement.left.outer
				//  );

				all_Panels = all_Panels.concat(state.placement.left.inner);
				// console.log(
				// 	'state.placement.left.inner:',
				// 	state.placement.left.inner
				//  );

				all_Panels = all_Panels.concat(state.placement.right.inner);
				// console.log(
				// 	'state.placement.right.inner:',
				// 	state.placement.right.inner
				//  );

				all_Panels = all_Panels.concat(state.placement.right.outer);
				// console.log(
				// 	'state.placement.right.outer:',
				// 	state.placement.right.outer
				//  );

				for (var i = 0, l = all_Panels.length; l > i; i++) {
					draw_Path(all_Panels[i], state.transforms[i]);
				}

				try {
					if (state.middle.value === 'center') {
						draw_Path(
							state.middle.character,
							state.middle.transforms[0]
						);

						draw_Path(
							state.middle.character,
						 	state.middle.transforms[1]
						 );
					}
				} catch(e) {
					// console.log('try catch for state.middle.value === center', e);
				}

				// console.log(
				// 	'state before draw path', state
				// );

				function draw_Path(current_Character, transform_Alteration) {
					// Add tracking so that it is around the character rather then after
					var heightMod = state.svg.height/5;

					if (typeof carolina !== 'undefined' &&
						previous_Team_Choice === 'away') {
						heightMod -= 15;
					}

					var current_Transform_String = ('t'+  (transform_Alteration)+','+ heightMod).toString(),
						inside_Path = font[current_Character],
						transformed_Path = Raphael.transformPath(inside_Path, current_Transform_String);

					//pointer
					if (!$('body').hasClass('product-nfl')) {
						paintSvg({
							path: transformed_Path,
							color: current_Color,
							stroke_Width: outlines.characters.width,
							character: current_Character,
						});
					}
				}
				// calc the width now
				// get position of first and last character..

				function __getMin(array){
					return Math.min.apply(Math, array);
				}

				function __getMax(array){
					return Math.max.apply(Math, array);
				}

				if (typeof phil !== 'undefined') {
					if (getInputValue().length !== 0) {
						var allPaths = document.getElementsByTagName('path');

						var coordsArray = [];

						for (var ai2 = 0; allPaths.length > ai2; ai2++) {
							if (ai2, allPaths[ai2].getAttribute('clip-path') === 'url(#clip-path)') {
								// get its coordinates
								coordsArray.push( Raphael.parsePathString( allPaths[ai2].getAttribute('d') )[0][1] );
							}
						}

						// console.log(
						// 	'coordsArray', coordsArray
						// );

						// getMin here gives us the first character in our input word
						var widthAfterPaint = __getMax(coordsArray) - __getMin(coordsArray);
						widthAfterPaint += characterObject.widths[all_Panels[all_Panels.length - 1]]/2; // and the last characters width

						// console.log(
						// 	'__getMin(coordsArray)', __getMin(coordsArray)
						// );
						// our paint should start at this position plus padding


						if (!widthAfterPaint) { // this is for one character
							widthAfterPaint = characterObject.character_Width_Total + 5;
						}

						var philBgPadding = 13;

						widthAfterPaint += philBgPadding; // some padding
						// get base character height of I
						var philBgHeight = Raphael.pathBBox(font.A).height + philBgPadding;
						// get the bottom of a character that is painted

						var heightAdjust = (state.svg.height/5) - Raphael.pathBBox(font.I).height + philBgPadding + 2.5;


						// the centering here is the problem
						// how can I get the value of the first characters bounding box

						// get the character width after paint

						var philBgBlock_X = __getMin(coordsArray) - tracking - (philBgPadding/4) ;

						var philBgBlock = svg_Canvas.rect(philBgBlock_X, heightAdjust, widthAfterPaint, philBgHeight);

						var philBgColor;

						if (current_Color[0] === '#FFFFFF') {
							philBgColor = '#000000';
						} else {
							philBgColor = '#dfdfdf';
						}

						if (getInputValue().length) {

							philBgBlock.attr({'fill': philBgColor, 'stroke': 'none', 'clip-path': 'url(#clip-path)'});

							philBgBlock.toBack();

						} else {

							$('#current-svg-canvas rect').remove();

						}

					}
				}
			}

			function checkCenter(total_Width, split_Ends_I) {
				// console.log(
				// 	'checkCenter(total_Width:'+total_Width+', split_Ends_I:'+split_Ends_I+')'
				// );

				if (!total_Width) {
					return;
				}

				var tolerance = state.tolerance,
					zero_Approx = state.zero_Approx,
					widths = characterObject.widths,
					half_Width = total_Width/2,
					counted_Widths = 0,
					total = characterObject.array.length;

				// console.log(
				// 	'inside checkCenter -- characterObject: ', characterObject
				// );

				// not all the characters in the character object,
				// console.log(
				// 	' half_Width: ', half_Width
				// );

				for (var i = 0; total > i; i++) {
					var current_Width = widths[characterObject.array[i]];

					// if the left hand character is less than half the width,
					// and the current character plus the next character is less than half the width
					// continue finding the middle character
					// else find the ratio of the middle character and which side is larger
					//
					// requested that if the name has even characters don't split...
					// they probably actually want a ratio but lets override for now
					// checks if the input value was even,
					// if it was even then this results in 0

					// Breaks on the correct letter at this point
					// this is getting the wrong middle character with MYIIICUSTOM
					// its swapping around the C and U
					//
					// how to check for the middle character?
						var mod = 0;
						if (getInputValue().length % 2 !== 0) {
							state.middle = {};
							i = Math.floor(total/2);


							state.middle.character = characterObject.array[i];
							// console.log('399: state.middle: ', state.middle);
							// so this correctly adds the w, since its over the threshold

							mod = state.placement.left.outer.length || 0;

							state.middle.placement = i + mod;

							// console.log('state: ', state);

							// Has correct middle character at this point
							// console.log('state.middle.character: ', state.middle.character);

							keepChecking(i, counted_Widths, current_Width, half_Width, total_Width, tolerance, zero_Approx, widths, split_Ends_I);
							return;
						} else {
						if (counted_Widths < half_Width) {
							counted_Widths += current_Width;
							// this addition isn't taking tracking into account
							// And it should not take it into account, will cause incorrect layout

							// console.log(
							// 	'i: ', i,
							// 	' cur_Width: ', current_Width,
							// 	' char: ', characterObject.array[i],
							// 	' count_Widths: ', counted_Widths
							// );

							// this part needs to be rewritten
							if ((counted_Widths) > half_Width) {
								// this means that the left is before the center

								state.middle = {};

								if (getInputValue().length % 2 !== 0) {

									state.middle.character = characterObject.array[i];
									// console.log('399: state.middle: ', state.middle);
									// so this correctly adds the w, since its over the threshold

									mod = state.placement.left.outer.length || 0;

									state.middle.placement = i + mod;
								}

								// console.log('state: ', state);

								// Has correct middle character at this point
								// console.log('state.middle.character: ', state.middle.character);

								keepChecking(i, counted_Widths, current_Width, half_Width, total_Width, tolerance, zero_Approx, widths, split_Ends_I);
								return;
							}

						} else {
							// this means that the left is after the center

							// console.log('___________ !!! line 421: left is after center !!! ___________');
							state.middle = {};
							state.middle.character = characterObject.array[i];

							keepChecking(i, counted_Widths, current_Width, half_Width, total_Width, tolerance, zero_Approx, widths, split_Ends_I);
							return;
						}
					}
				}
			}

			function keepChecking(i, counted_Widths, current_Width, half_Width, total_Width, tolerance, zero_Approx, widths, split_Ends_I) {
					
				if (getInputValue().length % 2 !== 0) {
				  var col_data = $(inputcoltype_Selector).val();
                  if (col_data == 'Tri Layer Technology Custom with personalized name and number Chair'){
                  	tolerance += -13;
                  }else{
                  	tolerance += 9999;
                  }
					// force a middle split on odd character counts
				}
              


				// console.log('state.middle.character: ', state.middle.character);
				var diff = {};
				// created a new object to store the values used to calculate the difference
				//

				// this gets the diff, but doesn't check the character at all
				diff.remaining = Math.abs(half_Width - counted_Widths);
				// subtracting this will always give you the remaining right
				// side of the character
				// wether its large or small, it should always be positive as well
				// making the Math.abs do nothing

				// lets log this and test againced the object
				// so if the left side is bigger
				// as in the case of waltono
				// the t is split to the right, when even this says it should be set to the left
				// the ratio could also be increased to allow the split to happen

				// console.log('diff.remaining: ', diff.remaining);

				// where did half width come from
				// half width is half the total width of all the characters

				// counted widths is the current counted amount
				// so if a b c d e,

				// we would be at c, and we would have counted the widths of a + b + c
				// so half the total width minus the counted width would give us
				// the overflow, but on which side
				// --- --- --- --- ---

				// counted half is --- --- ---
				// actual half is --- --- -|
				// subtract the two and you get  |-
				// the right hand side as the remainder.


				diff.left = Math.abs(diff.remaining - current_Width);
				// console.log('diff.remaining - current_Width: ', diff.remaining - current_Width);
				// the difference of the left side of the letter
				// and the difference of the right side of the letter

				diff.right = Math.abs(diff.left - current_Width);
				// console.log('diff.left - current_Width ', diff.left - current_Width);

				if (diff.left < diff.right) {
					diff.ratio = diff.right/diff.left;

				} else {
					diff.ratio = diff.left/diff.right;

				}
				// can we just add a hard override for centre of odd character counts
				// this is wrong for left hand side split

				state.middle.diff = diff;

				// console.log('diff: ', diff);
				// console.log('state: ', state);

				if (diff.ratio > 1) {
					if (diff.ratio < tolerance) {
						state.middle.value = 'center';

					} else {
						// so this is greated than the tolerance, and is saying to move it to the left
						if (diff.left > diff.right) {
							state.middle.value = 'left';
							// this says, correctly, that the character is left hand side
							// why does it move it to the right

						} else {
							// does this ever happen?
							// console.log('line 465: state.middle.value = right');
							state.middle.value = 'right';

						}
					}
				} else if (diff.ratio < tolerance) {
					state.middle.value = 'center';
				}


				// for the my custom word, this says the u is further on the left hand side


				// console.log('after diff calculation', state.middle);


				// remove the center character from the array

				// console.log(
				// 	'467: before - characterObject.array:', characterObject.array
				// );


				if (getInputValue().length > 3) {
					// this force split on edge cases causes the wrong letter to be placed

					if (getInputValue().length % 2 !== 0) {
						// for center, but for which character?
						//
						// WARNING! - this was causing an arrangement bug
						// from the force of the middle character

						//
						// why is this even here?
						// this never worked before, its also incorrect
						// what was it trying to fix?

						// if (state.middle.diff.ratio < tolerance &&
						// 	state.middle.diff.left > state.middle.diff.right) {
						// // 	// why didn't this trigger?
						// // 	// if the tolerance is greater,
						// // 	// set the middle character to the next character
						// // 	// console.log('test for tolerance middle check !! ________');
						// // 	// in which direction??

						// 	state.middle.character = characterObject.array[
						// 		state.middle.placement + 1
						// 	];
						// 	// and add one to its "placement" in the total layout
						// 	state.middle.placement++;
						// }

						// what if the tolerance is greater
						// and the left is bigger then the right
						// this is happening because we are assuming the split is happening on the middle character
						// but in BOWIING the split is on the W
						// it should be on the I

						// state.middle.value = 'center';
					} else {
						// console.log('!! the word count is even !!');
					}
				}

				if (getInputValue().length % 2 !== 0) {
					if (state.middle.value === 'center') {
						// This removes the middle character from the main array
						// when its been placed middle

						// here we need to also change the removal
						// this is correct in the current bug instance - (checking bowling)
						// console.log( characterObject.array );

						// what bug is this causing?

						// if (state.middle.diff.left < state.middle.diff.right) {
						characterObject.array.splice(state.middle.placement - split_Ends_I, 1);
						// } else {
							// characterObject.array.splice(state.middle.placement - split_Ends_I, 1);
						// }

						// console.log( characterObject.array );
					}
				}

				// console.log(
				// 	'475: after - characterObject.array:', characterObject.array
				// );


				for (var a = 0, b = characterObject.array.length; a < b; a++) {
					var this_Char = characterObject.array[a];

					// console.log(
					// 	'a: ', a,
					// 	'b: ', b,
					// 	'this_Char: ', this_Char
					// );

					// this needs to know if the center was split on the left or the right
					// assuming it breaks on the left always
					// console.log('state.middle: ', state.middle);
					var valueToCheckAgainced;

					// it used to be right, but we overide that now
					// so the real question is, are the coditions that make it right
					// triggered

					if (diff.left < diff.right) {
						// whats the real question here

						// console.log('______ testing diff.left odd character count rounding _____');
						// console.log('getInputValue().length % 2 !== 0: ', getInputValue().length % 2 !== 0 );
						if (state.middle.value === 'right') {
							valueToCheckAgainced = Math.ceil(b/2);
							// should this really ever happen?
							// if char count is odd,
							// is the value to be checked againced the character pos of the split
							// 3 would be okay if the value wasn't odd?
							// ever?
							// when would be the case that the middle amount is not the char
							//

						} else {
							valueToCheckAgainced = Math.floor(b/2);

							// this is just asking, is the current value over half
						}
					} else {
						valueToCheckAgainced = Math.floor(b/2);
						// here we need to check if the center character came before the characters
						// being placed on the left hand list array

						// valueToCheckAgainced = state.middle.placement;
						// if and only if what?

					}

					// console.log('a: ', a);
					// console.log('valueToCheckAgainced: ', valueToCheckAgainced);

					if (getInputValue().length % 2 !== 0) {
						// console.log('odd letter count');
						// you can't just force it to be center,
						// all the other calculations depend on this value.ey
						// state.middle.value = 'center';
					}
					// the question is


					// okay but why are we missing a character,
					// at what point does this skip over a character

					// here can we check if the middle character would come before
					// how
					// console.log('671: characterObject.array: ', characterObject.array);
					// in this instance the third character " I " is after the center
					// character, since we know
					// state.middle.placement
					// state.middle.value
					// if its left and its placement is less then the amount to split

					if (state.middle.value === 'center' &&
						state.middle.placement < valueToCheckAgainced) {
						valueToCheckAgainced = state.middle.placement;
					}

					// console.log(
					// 	'_____a: ', a,
					// 	'_____valueToCheckAgainced: ', valueToCheckAgainced
					// );

					if (a < valueToCheckAgainced) {
						// console.log('if this_Char: ', this_Char);
						// it gets it wrong here
						state.placement.left.inner.push(this_Char);
						state.panels.total.left.inner += widths[this_Char];

					} else {
						// console.log('else this_Char: ', this_Char);
						// the point at which we add to the width... doesn't matter here
						// but we want this to happen after for this character
						state.placement.right.inner.push(this_Char);
						state.panels.total.right.inner += widths[this_Char];
					}
				}
				// console.log('check state after array replacement: ', state.placement);


				// here we need to check if the inside panels (a, b, c, d) in this case panels b and c
				// and see if one side has less characters then the other
				//
				// Then we need to check what the best solution is:
				// does it fit better if we split the center
				// should we move the ends back in ?

				// this part is unfinished and unimplemented logic
				// the real question is

				// If the left or right inner panel is larger then the panel can contain...
				// split the ends

				// console.log(
				// 	'state.placement.left.inner: ', state.placement.left.inner,
				// 	'state.placement.right.inner: ', state.placement.right.inner
				// );

				var mid_Width = characterObject.widths[state.middle.character],
					ratio1 = 0,
					ratio2 = 0;

				// this is checking for overflow of the center panels
				// after the center split
				if (mid_Width) {
					ratio1 = (
						state.panels.total.left.inner / state.panels.total.right.inner
					);

					ratio2 = (
					 ( mid_Width/2 + state.panels.total.right.inner )/(state.panels.total.left.inner - mid_Width/2 )
					);
				}
				// why do we want ratios?


				// console.log('BEFORE -- state.panels.total.left.inner: ',state.panels.total.left.inner);

					// console.log(
					// 	'test',
					// 	'ratio1: ', ratio1,
					// 	'ratio2: ', ratio2
					// );
				if (ratio1 > ratio2) {
					// here it is
					// bail the pop... why the pop? (removes the last character in the array)
					// check if the last character in the array
					// is the middle character
					// and that the middle hasn't been
				}
				// FLAG! - ABOVE ^ turning off problematic, and probably wrong check

				// console.log('AFTER -- state.panels.total.left.inner: ',state.panels.total.left.inner);

				// console.log('line 560: state.middle.value: ', state.middle.value);

				// adds the center, after its been split to the left and right panels
				if (state.middle.value === 'center' && state.middle.character) {
					state.panels.total.left.inner += characterObject.widths[state.middle.character]/2;
					state.panels.total.right.inner += characterObject.widths[state.middle.character]/2;
				}

				// console.log('state.middle.character', state.middle.character);

				// console.log('characterObject.widths[state.middle.character]', characterObject.widths[state.middle.character]);

				if (split_Ends_I) {
					state.margins = {
						left: spaceAround('left'),
						right: spaceAround('right'),
					};
				}
              	
				
				function spaceAround(p) {
					// console.log(
					// 	'spaceAround(p) p: ', p,
					// 	'state.panels.width: ', state.panels.width,
					// 	'state.panels.total['+p+'].inner: ', state.panels.total[p].inner
					// );
					return (state.panels.width - state.panels.total[p].inner)/state.placement[p].inner.length;
				}

				return;
			}

			function getTransformStrings() {
				state.transforms = [];

				state.transforms = state.transforms.concat( calcString(state.placement.left.outer, 'left outer') );
				state.transforms = state.transforms.concat( calcString(state.placement.left.inner, 'left inner') );
				state.transforms = state.transforms.concat( calcString(state.placement.right.inner, 'right inner') );
				state.transforms = state.transforms.concat( calcString(state.placement.right.outer, 'right outer') );

				function calcString(p, v) {
					if (!p) {
						return;
					}
					var carolinaAway;
					if (typeof carolina !== 'undefined' &&
						previous_Team_Choice === 'away') {
						carolinaAway = true;
					}

					var prev_Width = 0,
						transform_Strings = [],
						string_Mod = 0,
						justify_Margin = 0;

					if (v === 'left outer' || v === 'left inner') {
						p.reverse();
					}
                  

					// console.log('state.margins.left', state.margins);

					if (v === 'left outer') {
						string_Mod = panelsObject.panels.Left_1.top_Right_X;
                      
						if (carolinaAway) {
							string_Mod--;
						}

					} else if (v === 'left inner') {
						string_Mod = panelsObject.panels.Left_2.top_Right_X;

						if (carolinaAway) {
							string_Mod--;
						}

						if (state.margins) {
							justify_Margin = state.margins.left || 0;
                         
						}

					} else if (v === 'right inner') {
						string_Mod = panelsObject.panels.Right_1.bottom_Left_X;
						if (carolinaAway) {
							string_Mod++;
						}

						if (state.margins) {
							justify_Margin = state.margins.right || 0;
						}

					} else if (v === 'right outer') {
						string_Mod = panelsObject.panels.Right_2.bottom_Left_X;
						if (carolinaAway) {
							string_Mod++;
						}
					}

					// we need to force a split on odd number values
					try {
						if (getInputValue().length % 2 !== 0) {
							var middle_Character_Width = 0;
							if (state.middle.value === 'center' && v === 'left inner' ||
								state.middle.value === 'center' && v === 'right inner') {
								middle_Character_Width = characterObject.widths[state.middle.character];
								//	okay this is the correct amount but odd
								// do we have the middle character?
								// characterObject[state.middle.character].widths
								// console.log('756 middle_Character_Width: ', middle_Character_Width);
								// console.log('756 state: ', state);

								prev_Width += middle_Character_Width/2;

								// how should this be calculated
								// from the top right of the left center panel
								// the right hand side still gets incorrect addition
								// console.log('top right of the left center panel: ', panelsObject.panels.Left_2.top_Right_X);
								// console.log('panelsObject.panels.Right_1.top_Left_X: ', panelsObject.panels.Right_1.top_Left_X);
								var middleAdjust = -1.5,
									middleSpread = {
										left: 0,
										right: 0
									};

								if (typeof middleSplitAdjustment !== 'undefined') {
									middleAdjust = middleSplitAdjustment;
								}

								if (typeof middleSpreadAdjustment !== 'undefined') {
									middleSpread = middleSpreadAdjustment;
								}

								var middleLeftWidth = panelsObject.panels.Left_2.top_Right_X + middleAdjust;
								middleLeftWidth -= middleSpread.left;
								middleLeftWidth -= middle_Character_Width;
								middleLeftWidth += middle_Character_Width/2;

								var middleRightWidth = panelsObject.panels.Right_1.top_Left_X + middleAdjust;
								middleRightWidth += middleSpread.right;
								middleRightWidth -= middle_Character_Width/2;

								state.middle.transforms = [
									// so this is off a little bit already
									// starting with these at

									// (panelsObject.panels.Left_2.top_Right_X - 2) - middle_Character_Width,
									// (panelsObject.panels.Right_1.top_Left_X - 2)

									// they are equally to far left and right (the full character)
									middleLeftWidth,
									middleRightWidth
									// subtracting the last one by half, should move it in the correct direction
								];

								// prev_Width++;
								// why were we adding one here?
							}

							// if (state.middle.value === 'center' && v === 'right inner') {
								// middle_Character_Width = state.middle.diff.left + state.middle.diff.right;

								// okay so without this now the right side is calculated correctly
								// but the left hand side has the icorrect addition of margins
								// prev_Width -= middle_Character_Width/4;
							// }
						}
					} catch(e) {
						// console.log('line 639: try catch state.middle.value if statement', e);
					}

					for (var i = 0, l = p.length; l > i; i++) {
						if (v === 'right inner') {
							prev_Width += justify_Margin/2;
							transform_Strings.push(string_Mod + prev_Width);

							// so this adds to the right, plotting from the right
							// and thats why we get the incorrect value
							prev_Width += justify_Margin/2;
							prev_Width += characterObject.widths[p[i]];
						}

						if (v === 'right outer') {
							if (i !== 0) {
								prev_Width += characterObject.widths[p[i - 1]];
							} else {
							// subtract half the  middle but only once
							}
							// right hand biased still isn't solved

							transform_Strings.push(string_Mod + prev_Width);
						}

						if (v === 'left inner') {
							// the previous character width, plus the justify margins
							// which are divided in half and wrapped around
							// wouldn't that be the same as just adding the justify margin
							// how would this wrap around?
							// this is exactly the same as adding it to the right of the character

							// so how do we actually wrap it around
							// better yet, what are we trying to do here
							// we are centering the left are right inner panels.

							// this isn't caluating the margin of the center character, and the
							// when should the next margin be added?

							prev_Width += justify_Margin/2;
							// console.log('prev_Width: ', prev_Width);
							// console.log('justify_Margin/2: ', justify_Margin/2);
							prev_Width += characterObject.widths[p[i]];
							prev_Width += justify_Margin/2;
							// this amount needs to have the full amount of the
							// middle char half amount subtracted from all its parts

							transform_Strings.push(string_Mod - prev_Width);
						}

						if (v === 'left outer') {
							// this is getting calulated incorrectly by one on both sides
							prev_Width -= characterObject.widths[p[i]];
							transform_Strings.push(string_Mod + prev_Width);

						}


					}

					return transform_Strings;
				}
			}

			function northCarolinaCheckForAtheltic() {
				var hiddenInput = $('<input id="hidden-input" type="hidden" name="properties[name]"" value="WOLFPACK" />');

				if ( $('.swatch-element > input[value="Athletic"]:checked').length ) {
					$('#custom-name').attr('disabled', true);
					$('#custom-name').attr('value', 'WOLFPACK');
					$('#custom-name').attr('name', '');
					$('#small-caps-toggle, label[for="small-caps-toggle"]').addClass('hidden');

					if (!$('#hidden-input').length) {
						$('#custom-name').after(hiddenInput);
					}
				} else {
					$('#custom-name').attr('disabled', false);
					$('#custom-name').attr('name', 'properties[name]');
					$('#small-caps-toggle, label[for="small-caps-toggle"]').removeClass('hidden');

					if (!$('#hidden-input').length) {
						$('#custom-name').remove();
					}
				}
			}

			if (typeof northCarolina !== 'undefined') {
				northCarolinaCheckForAtheltic();

				$('.swatch-element > input').on('click', function() {
					northCarolinaCheckForAtheltic();
				});
			}
			// Selecting color 
			$('.swatch-element > input').on('click', function() {
				chooseColor(this.value);
			});
          

			if (typeof first_Color_Choice === 'undefined') {
				first_Color_Choice = $('.swatch-element input[name="option-0"]:checked').val();
			}

			var previous_Color_Choice = first_Color_Choice,
				previous_Team_Choice = 'home';

			if (typeof homeStringChange !== 'undefined') {
				previous_Team_Choice = homeStringChange;
			}

			var current_Color_Numbers = colors.numbers[previous_Team_Choice],
				current_Color = colors.characters[previous_Team_Choice];

			function capitalizeString(p) {
				// console.log('capitalizeString p.length: ', p.length);
				p = p.replace(/ /g, '');
				// console.log('capitalizeString p.charAt(0): ', p.charAt(0));
				var result = p.charAt(0).toUpperCase() + p.slice(1);
				// console.log('capitalizeString result:', result);
				return result;
			}

			if (typeof imageSourceResult === 'undefined') {           
				imageSourceResult = blankBackImageSrc;
              	//console.log('Image Source: '+imageSourceResult);
			}

			var homeStringToCheck = 'Home',
                darkStringToCheck = 'Dark',
                lightStringToCheck = 'Light',
                alternateStringToCheck = 'Alternate',
				awayStringToCheck = 'Away',
          		greyStringToCheck = 'Grey',
//           		brownStringToCheck = 'Brown',
                beigeStringToCheck = 'Beige',
                powderStringToCheck = 'Powder',
            	navyStringToCheck = 'Navy',
                royalStringToCheck = 'Royal',
                blueStringToCheck = 'Blue',
          		extraStringToCheck = 'Extra',
          		thirdStringToCheck = 'Third',
                retroStringToCheck = 'Retro';

			if (typeof retroStringChange !== 'undefined') {
				retroStringToCheck = capitalizeString(retroStringChange);
			}
          
            if (typeof homeStringChange !== 'undefined') {
				homeStringToCheck = capitalizeString(homeStringChange);
			}

			if (typeof awayStringChange !== 'undefined') {
				awayStringToCheck = capitalizeString(awayStringChange);
			}
          
          	if (typeof darkStringChange !== 'undefined') {
				darkStringToCheck = capitalizeString(darkStringChange);
			}
          
          	if (typeof lightStringChange !== 'undefined') {
				lightStringToCheck = capitalizeString(lightStringChange);
			}
            if (typeof alternateStringChange !== 'undefined') {
				alternateStringToCheck = capitalizeString(alternateStringChange);
			}
            
          
          	if (typeof greyStringChange !== 'undefined') {
				greyStringToCheck = capitalizeString(greyStringChange);
			}
          
//           	if (typeof brownStringChange !== 'undefined') {
// 				brownStringToCheck = capitalizeString(brownStringChange);
// 			}
          
          	if (typeof beigeStringChange !== 'undefined') {
				beigeStringToCheck = capitalizeString(beigeStringChange);
			}
          
          	if (typeof powderStringChange !== 'undefined') {
				powderStringToCheck = capitalizeString(powderStringChange);
			}
            
            if (typeof navyStringChange !== 'undefined') {
				navyStringToCheck = capitalizeString(navyStringChange);
			}
          	
          	if (typeof orangeStringChange !== 'undefined') {
				orangeStringToCheck = capitalizeString(orangeStringChange);
			}
          
          	if (typeof royalStringChange !== 'undefined') {
				royalStringToCheck = capitalizeString(royalStringChange);
			}
          
          	if (typeof extraStringChange !== 'undefined') {
				extraStringToCheck = capitalizeString(extraStringChange);
			}
          
            if (typeof thirdStringChange !== 'undefined') {
				thirdStringToCheck = capitalizeString(thirdStringChange);
			}


			// $('.swatch-element input[name="option-1"]').click(function() {
			// 	var alternateImageValue = $('.swatch-element input[name="option-1"]:checked').val();
			// 	if (alternateImageValue) {
			// 		imageSourceResult.replace(homeStringToCheck, awayStringToCheck);
			// 		previous_Team_Choice = alternateImageValue.toLowerCase();
			// 	}
			// });

			var consoleCount = 0;
			function chooseColor(p) {
              //debugger;
				var cap,
					i = 0;

				var homeString = 'Home',
                    retroString = 'Retro',
					awayString = 'Away',
                    /*Custom Added*/          		
                    darkString = 'Dark',
              		lightString = 'Light',
                    alternateString = 'Alternate',
              		greyString = 'Grey',
//                     brownString = 'Brown',
                    beigeString = 'Beige',
                    powderString = 'Powder',
                    navyString = 'Navy',
                    orangeString = 'Orange',
                    royalString = 'Royal',
                    extraString = 'Extra',
                    thirdString = 'Third'; 
              
			    if (typeof retroStringChange !== 'undefined') retroString = capitalizeString(retroStringChange);		
				if (typeof homeStringChange !== 'undefined') homeString = capitalizeString(homeStringChange);

				if (typeof awayStringChange !== 'undefined') awayString = capitalizeString(awayStringChange);
              
              	if (typeof darkStringChange !== 'undefined') darkString = capitalizeString(darkStringChange);
              
              	if (typeof lightStringChange !== 'undefined') lightString = capitalizeString(lightStringChange);
              
              	if (typeof greyStringChange !== 'undefined') greyString = capitalizeString(greyStringChange);
                if (typeof alternateStringChange !== 'undefined') alternateString = capitalizeString(alternateStringChange);
              
//               	if (typeof brownStringChange !== 'undefined') brownString = capitalizeString(brownStringChange);
              
              	if (typeof beigeStringChange !== 'undefined') beigeString = capitalizeString(beigeStringChange);
              
              	if (typeof powderStringChange !== 'undefined') powderString = capitalizeString(powderStringChange);
              
              	if (typeof navyStringChange !== 'undefined') navyString = capitalizeString(navyStringChange);
              
              	if (typeof orangeStringChange !== 'undefined') orangeString = capitalizeString(orangeStringChange);
              
              	if (typeof royalStringChange !== 'undefined') royalString = capitalizeString(royalStringChange);
              
              	if (typeof extraStringChange !== 'undefined') extraString = capitalizeString(extraStringChange);

                if (typeof thirdStringChange !== 'undefined') thirdString = capitalizeString(thirdStringChange);
              
				if ( imageSourceResult.indexOf('Molson') !== -1) {
					var storeStartOfString = imageSourceResult.split('_Back_')[0] + '_Back_';
					var endOfString = imageSourceResult.split('_Back_')[1];
					cap = capitalizeString(previous_Color_Choice);
					var moddedEndOfString = endOfString.replace(cap, p);
					imageSourceResult = storeStartOfString + moddedEndOfString;

				} else {
					imageAssetArray.map(function(imageUrl) {
						consoleCount++;
						//console.log(consoleCount, 'CHECK_____ p, and capped', p, capitalizeString(p));
						//console.log(consoleCount, 'CHECK_____ homeString', homeString);
						//console.log(consoleCount, 'CHECK_____ awayString', awayString);
						//console.log(consoleCount, 'CHECK_____ previous_Team_Choice', previous_Team_Choice);
						//console.log(consoleCount, 'CHECK_____ previous_Color_Choice', previous_Color_Choice);
						//console.log(consoleCount, 'CHECK_____ imageUrl', imageUrl);

						if (p === homeString || p === awayString || p === retroString) {
							cap = capitalizeString(previous_Team_Choice);
                          	//console.log('Previous Team choice was: '+cap);
                        /*Custom Added*/
                        } else if (p === darkString || p === lightString || p === greyString ||p === alternateString || p === beigeString || p === powderString || p === navyString || p === orangeString || p === royalString || p === extraString || p === thirdString  ){
                          	cap = capitalizeString(previous_Team_Choice);
                          	//console.log('Previous Team choice was: '+cap);
						} else {
							cap = capitalizeString(previous_Color_Choice);
						}

						// console.log(consoleCount, 'CHECK_____ cap', cap);
						imageSourceResult = imageSourceResult.replace(
							capitalizeString(cap), capitalizeString(p)
						);
						//console.log(consoleCount, 'CHECK_____ imageSourceResult', imageSourceResult);
					});

				}

				p = p.toLowerCase();

				if (p === homeString.toLowerCase() || p === awayString.toLowerCase() || p === retroString.toLowerCase()) {
					current_Color = colors.characters[p];
					current_Color_Numbers = colors.numbers[p];
					previous_Team_Choice = p;
                /*Custom Added*/ 
                } else if (p === darkString.toLowerCase() 
                           || p === lightString.toLowerCase() 
                           || p === greyString.toLowerCase() 
                           || p === alternateString.toLowerCase() 
                           || p === beigeString.toLowerCase() 
                           || p === powderString.toLowerCase() 
                           || p === navyString.toLowerCase() 
                           || p === orangeString.toLowerCase()
                           || p === royalString.toLowerCase()
                           || p === extraString.toLowerCase()
                           || p === thirdString.toLowerCase()) {
                  
              		current_Color = colors.characters[p];
					current_Color_Numbers = colors.numbers[p];
					previous_Team_Choice = p;
                    
            	} else {
					previous_Color_Choice = p;
                  	//console.log('Color Now: '+previous_Color_Choice);
                  	//console.log('Team Now: '+previous_Team_Choice);
				}

				activeFunction();
			}

			function closeEnds(path) {
				path = path.toString().replace(/M/g, 'ZM').replace('ZM','M') + 'Z';
				return path;
			}

			function useUrlToSetInput() {
				if (location.href.indexOf('?name=') !== -1) {
					try {
						var urlSplit = location.href.split('?name=');

						var urlWithoutName = urlSplit[0];

						var nameInUrl = urlSplit[1].replace(/-/g, ' ').replace(/%20/g, ' ');

						nameInUrl = nameInUrl.substring(0, 12);

						if (nameInUrl.length > 0) {
							$('#custom-name').val(
								nameInUrl
							);
						}

						// will figure out this functionality after
						// $('#custom-name').on('onkeydown', function() {
						// });

					} catch(e) {
						// console.log(e);
					}
				}
			}
			useUrlToSetInput();


			function paintSvg(p, letter) {
				for (var iNewYork = 0; iNewYork < 3; iNewYork++) {
					var newYorkOutline;
					if (typeof newYork !== 'undefined') {
						if (p.number) {
							newYorkOutline = svg_Canvas.path(
								closeEnds(
									Raphael.transformPath(
										p.path,
										't-'+iNewYork+', '+iNewYork
									)
								)
							);

							newYorkOutline.attr({
								'fill': 'none',
								'stroke': p.color[1],
								'stroke-width': 5,
								'clip-path': 'url(#clip-path-outer)'
							});
						} else if (letter &&
									 letterChoice() === 'C' ||
									 letterChoice() === 'A') {
							newYorkOutline = letter_Canvas.path(
								closeEnds(
									Raphael.transformPath(
										p.path,
										't-'+(iNewYork/2)+', '+(iNewYork/2)
									)
								)
							);

							newYorkOutline.attr({
								'fill': 'none',
								'stroke': p.color[1],
								'stroke-width': 2
							});
						}
					}
				}

				for (var iEskimos = 0; iEskimos < 1; iEskimos++) {
					var EskimosOutline;
					if (typeof Eskimos !== 'undefined') {
						if (p.number) {
							EskimosOutline = svg_Canvas.path(
								closeEnds(
									Raphael.transformPath(
										p.path,
										't'+ 2 +', '+ 2
									)
								)
							);

							EskimosOutline.attr({
								'fill': 'none',
								'stroke': p.color[2],
								'stroke-width': 5,
								'clip-path': 'url(#clip-path-outer)'
							});
						} else if (letter && letterChoice() === 'C' || letterChoice() === 'A') {
							EskimosOutline = letter_Canvas.path(
								closeEnds(
									Raphael.transformPath(
										p.path,
										't'+ 1 +', '+ 1
									)
								)
							);

							EskimosOutline.attr({
								'fill': 'none',
								'stroke': p.color[2],
								'stroke-width': 2
							});
						}
					}
				}

				// pathcing a bug with the swatch template
				if (typeof referee !== 'undefined') {
					p.color = [
						"#FFFFFF",
						"#231F20",
					];
				}

				if (typeof academicIsActive !== 'undefined') {
					if (academicIsActive === true) {
						p.color = [
							"#14234b",
							"#b2b1ae",
						];
					}
				}

				if (typeof canadian_flag !== 'undefined' && letter) {
					p.color.push(letterAdjust.outline);
					p.stroke_Width = 0.35;
				}

				if (typeof bcLions !== 'undefined' && letter) {
				}
          if(typeof p.color !== 'undefined') {
				for (var i = p.color.length; i--;) {
					var el,
						current_Color = p.color[i];

					try {
						// p might not be defined
						if (p.number) {
							if (current_Color === '#FFFFFF' ||
								current_Color === '#FFF' ||
								current_Color === '#ffffff' ||
								current_Color === '#fff') {
								current_Color = '#dfdfdf';
							}
						}
					} catch (e) {}

					if (letter) {
						el = letter_Canvas.path(closeEnds(p.path));
					} else {
						el = svg_Canvas.path(closeEnds(
							// here we can perform a tracking adjustment
							// p.path
							Raphael.transformPath(p.path, 't'+ (tracking/2) + ', 0')
						));
					}

					var currentStrokeWidth;
					// Inlines the stroke on toronoto argonauts
					if (p.number && typeof argonauts !== 'undefined' ||
						p.number && typeof stampeders !== 'undefined' ||
						p.number && typeof blueBombers !== 'undefined' ||
						p.number && typeof bcLions !== 'undefined') {
						currentStrokeWidth = p.stroke_Width * i;
						if (i === 0) {
							// Draws an extra character over the fill layer
							if (typeof bcLions !== 'undefined' && p.number) {
								var bcLionsElOutline = svg_Canvas.path(closeEnds(Raphael.transformPath(p.path, 't'+ (tracking/2) + ', 0')));
								if (p.character !== ' ') {
									bcLionsElOutline.attr({'stroke': p.color[2], 'stroke-width': 1});
								}

								bcLionsElOutline.attr({'clip-path': 'url(#clip-path-outer)'});
							}

							if (p.character !== ' ') {
								el.attr({'stroke': p.color[1], 'stroke-width': p.stroke_Width + 1});
							} else {
								el.attr({'fill': 'none', 'stroke': 'none'});
							}

							if (p.number) {
								el.attr({'clip-path': 'url(#clip-path-outer)'});
							} else if (!letter) {
								el.attr('clip-path', 'url(#clip-path)');
							}

						} else {
							if (i === 1) {
								// Draws an extra character over the fill layer
								if (typeof bcLions !== 'undefined' && p.number) {
									var bcLionsEl = svg_Canvas.path(closeEnds(Raphael.transformPath(p.path, 't'+ (tracking/2) + ', 0')));
									if (p.character !== ' ') {
										bcLionsEl.attr({'fill': p.color[2], 'stroke': 'none'});
									}

									bcLionsEl.attr({'clip-path': 'url(#clip-path-bc-lions)'});
								}
							}

							if (p.character !== ' ') {
								el.attr({'fill': p.color[0], 'stroke': 'none'});
							} else {
								el.attr({'fill': 'none', 'stroke': 'none'});
							}

							if (p.number) {
								el.attr({'clip-path': 'url(#clip-path-inner)'});
							} else if (!letter) {
								el.attr('clip-path', 'url(#clip-path)');
							}
						}
					} else {
						if (typeof bcLions !== 'undefined') {
							if (i === 0) {
								if (p.character !== ' ') {
									el.attr({'fill': current_Color, 'stroke': 'none'});
								} else {
									el.attr({'fill': 'none', 'stroke': 'none'});
								}

								if (p.number) {
									el.attr({'clip-path': 'url(#clip-path-inner)'});
								} else if (!letter) {
									el.attr('clip-path', 'url(#clip-path)');
								}
							} else {
								currentStrokeWidth = p.stroke_Width * i;

								if (letter) {
									current_Color = 'none';
								}

								if (p.character !== ' ') {
									el.attr({'stroke': current_Color, 'stroke-width': currentStrokeWidth});
								} else {
									el.attr({'fill': 'none', 'stroke': 'none'});
								}

								if (p.number) {
									el.attr({'clip-path': 'url(#clip-path-outer)'});
								} else if (!letter) {
									el.attr('clip-path', 'url(#clip-path)');
								}
							}
						} else {
							if (i === 0) {
								if (p.character !== ' ') {
									el.attr({'fill': current_Color, 'stroke': 'none'});
								} else {
									el.attr({'fill': 'none', 'stroke': 'none'});
								}

								if (p.number) {
									el.attr({'clip-path': 'url(#clip-path-inner)'});
								} else if (!letter) {
									el.attr('clip-path', 'url(#clip-path)');
								}
							} else {
								currentStrokeWidth = p.stroke_Width * i;
								if (p.character !== ' ') {
									el.attr({'stroke': current_Color, 'stroke-width': currentStrokeWidth});
								} else {
									el.attr({'fill': 'none', 'stroke': 'none'});
								}

								if (p.number) {
									el.attr({'clip-path': 'url(#clip-path-outer)'});
								} else if (!letter) {
									el.attr('clip-path', 'url(#clip-path)');
								}
							}
						}
					}
				}//For loop ends
          	  }
			}

			function drawNumbers() 	{
				var input_Value = getNumberValue(),
					total_Width = 0,
					i = 0,
					number_Paths = [];

				createNumberClipPath();

				for (i = 0; input_Value.length > i; i++) {
					var n = number_Adjustments;
					var transformed_Path = Raphael.transformPath(
						font[input_Value[i]], 't' +
						n.left +', '+
						n.top +', s'+
						(n.width/font_size) +', '+
						(n.height/font_size)
					);

					// if (typeof academicIsActive !== 'undefined' && typeof numberTransformPathRegularFireTwice[1] === 'undefined' ) {
					// 	window.numberTransformPathRegularFireTwice.push(true);
					// } else if (typeof academicIsActive !== 'undefined' && typeof numberTransformPathAltFireTwice[1] === 'undefined') {
					// 	transformed_Path = Raphael.transformPath(
					// 		font[input_Value[i]], 't' +
					// 		n.left +', '+
					// 		n.top +', s'+
					// 		(n.width/font_size) +', '+
					// 		(n.height/font_size)
					// 	);
					// 	window.numberTransformPathAltFireTwice.push(true);
					// } else if (typeof academicIsActive === 'undefined') {
					// 	transformed_Path = Raphael.transformPath(
					// 		font[input_Value[i]], 't' +
					// 		n.left +', '+
					// 		n.top +', s'+
					// 		(n.width/font_size) +', '+
					// 		(n.height/font_size)
					// 	);
					// }

					// if (typeof athleticIsActive !== 'undefined') {
					// 	if (typeof numberTransformPathRegular === 'undefined') {
					// 		window.numberTransformPathRegular = transformed_Path;
					// 	}
					// }

					// if (typeof academicIsActive !== 'undefined') {
					// 	if (typeof numberTransformPathAlt === 'undefined') {
					// 		window.numberTransformPathAlt = transformed_Path;
					// 	}
					// }

					// if (typeof athleticIsActive !== 'undefined') {
					// 	if (athleticIsActive === true) {
					// 		number_Paths.push(numberTransformPathRegular);
					// 		total_Width += Raphael.pathBBox(numberTransformPathRegular).width;
					// 	}
					// } else {
					// 	number_Paths.push(transformed_Path);
					// 	total_Width += Raphael.pathBBox(transformed_Path).width;
					// }

					// if (typeof academicIsActive !== 'undefined') {
					// 	if (academicIsActive === true) {
					// 		number_Paths.push(numberTransformPathAlt);
					// 		total_Width += Raphael.pathBBox(numberTransformPathAlt).width;
					// 	}
					// } else {
						number_Paths.push(transformed_Path);
						total_Width += Raphael.pathBBox(transformed_Path).width;
					// }

					if (number_Adjustments.middle_Space) {
						total_Width += number_Adjustments.middle_Space;
					}
				}

				for (i = 0; input_Value.length > i; i++) {
					var this_Number = number_Paths[i],
						offsetMod = svg_Width/2,
						offsetBy = 4,
						oneOffset = 2;
                  

					if (typeof number_Adjustments.oneOffset !== 'undefined') {
						oneOffset = number_Adjustments.oneOffset;
					}

					if (typeof number_Adjustments.spreadNumberCenterGap !== 'undefined') {
						offsetBy += number_Adjustments.spreadNumberCenterGap;
					}

					if (input_Value.length === 2) {
						if (i) {
							if (input_Value[i] === '1') {
								offsetBy += oneOffset;
							}

							offsetMod += ((Raphael.pathBBox(this_Number).width/2) + offsetBy);
						} else {
							if (input_Value[i] === '1') {
								offsetBy += oneOffset;
							}

							offsetMod -= ((Raphael.pathBBox(this_Number).width/2) + offsetBy);
						}
					} else {
						if (input_Value[i] === '1') {
							if (typeof number_Adjustments.singleDigitOneOffset !== 'undefined') {
								offsetMod += number_Adjustments.singleDigitOneOffset;
							}
						}
					}

					var singleDigitSpread = 1;
					if (input_Value.length === 1) {
						if (typeof number_Adjustments.singleDigitSpread !== 'undefined') {
							singleDigitSpread = number_Adjustments.singleDigitSpread;
						}
					}

					var transform_String = ('t'+ offsetMod +','+ svg_Height/2.7 +', s'+ singleDigitSpread +', 1').toString(),
						path_Transform = Raphael.transformPath(this_Number, transform_String),
						outline_Amount = outlines.numbers.width;

					//pointer
					if (!$('body').hasClass('product-nfl')) {
						paintSvg({
							path: path_Transform,
							color: current_Color_Numbers,
							stroke_Width: outline_Amount,
							number: true,
						});
					}
                  
//                   	if (!$('body').hasClass('product-mlb')) {
// 						paintSvg({
// 							path: path_Transform,
// 							color: current_Color_Numbers,
// 							stroke_Width: outline_Amount,
// 							number: true,
// 						});
// 					}
				}

				function createNumberClipPath() {
					
                   var col_data = $(inputcoltype_Selector).val();
                  if (col_data == 'Tri Layer Technology Custom with personalized name and number Chair'){
                    var defs = document.createElementNS("http://www.w3.org/2000/svg", 'defs'); 
                    var outerPath = 'M131.8,131.9l0.3,0.2c0,16,0.1,58.3,0.4,67.1c0.1,1.8,4.4,2.1,6.3,2.2h0.5V201 c0-0.3-0.5-57.8-0.2-69l38.5,0.2c-2.1,15.4-4.9,45.5-7.8,65.5c0,0.3-0.4,1.8-0.2,2c0.6,0.7,2.2,0.8,2.9,0.8c1.6,0,3.6-0.4,3.7-1.5 c0.4-6.8,1.7-15.9,3.1-26.2c1.8-12.8,3.1-27.2,4.8-40.5c7.8,0.4,15.2,0.2,21.4,0.2c0.1,7.2,0.2,100.5,0.2,108.5H69.5v0l0-109.2 c5.6-0.1,12.2,0,18.1,0c3.1,21.4,6.8,50.4,8.5,65.7l0.3,1.7c0.1,1.1,1,1.4,2.6,1.4c0.7,0,2.3-0.1,2.9-0.8c0.2-0.2,0.3-0.5,0.3-0.8 l-0.7-2.3c-2-17.7-5.2-47.9-7.9-65L131.8,131.9z';
                    
                    var innerPath = 'M261,291H69l0.1-109.2c6.3-0.1,12.6-0.1,18.4-0.1c3.6,22.2,7.9,52.5,8.8,67.4 c0.1,1.4,5.5,1.4,5.3,0c-2.2-16.9-6.5-49.4-8.3-67.8c12.1,0,25.2-0.1,39.7,0c0,0,0,5.5,0,13.6c0,16.4,0.4,43.5,0.2,54.2 c0,1.5,5.4,2,5.4,2s0-31.8,0.3-43.2c0.4-16.3,0.2-26.3,0.2-26.3c10.7,0.1,25.5,0.3,39.3,0.5c-2.1,18.2-5.9,50.2-8.8,66.9 c-0.2,1.4,5.7,1.3,5.8-0.1c1.5-14.7,5.3-42.8,8.7-66.7c7.2,0.2,15,0.1,21.9,0.4C206.2,132.6,206,241,206,241z';
                  }else{
                    var defs = document.createElementNS("http://www.w3.org/2000/svg", 'defs');
                    var outerPath = 'M131.8,131.9l0.3,0.2c0,16,0.1,58.3,0.4,67.1c0.1,1.8,4.4,2.1,6.3,2.2h0.5V201 c0-0.3-0.5-57.8-0.2-69l38.5,0.2c-2.1,15.4-4.9,45.5-7.8,65.5c0,0.3-0.4,1.8-0.2,2c0.6,0.7,2.2,0.8,2.9,0.8c1.6,0,3.6-0.4,3.7-1.5 c0.4-6.8,1.7-15.9,3.1-26.2c1.8-12.8,3.1-27.2,4.8-40.5c7.8,0.4,15.2,0.2,21.4,0.2c0.1,7.2,0.2,100.5,0.2,108.5H69.5v0l0-109.2 c5.6-0.1,12.2,0,18.1,0c3.1,21.4,6.8,50.4,8.5,65.7l0.3,1.7c0.1,1.1,1,1.4,2.6,1.4c0.7,0,2.3-0.1,2.9-0.8c0.2-0.2,0.3-0.5,0.3-0.8 l-0.7-2.3c-2-17.7-5.2-47.9-7.9-65L131.8,131.9z';
                    var innerPath = 'M206,241H69l0.1-109.2c6.3-0.1,12.6-0.1,18.4-0.1c3.6,22.2,7.9,52.5,8.8,67.4 c0.1,1.4,5.5,1.4,5.3,0c-2.2-16.9-6.5-49.4-8.3-67.8c12.1,0,25.2-0.1,39.7,0c0,0,0,5.5,0,13.6c0,16.4,0.4,43.5,0.2,54.2 c0,1.5,5.4,2,5.4,2s0-31.8,0.3-43.2c0.4-16.3,0.2-26.3,0.2-26.3c10.7,0.1,25.5,0.3,39.3,0.5c-2.1,18.2-5.9,50.2-8.8,66.9 c-0.2,1.4,5.7,1.3,5.8-0.1c1.5-14.7,5.3-42.8,8.7-66.7c7.2,0.2,15,0.1,21.9,0.4C206.2,132.6,206,241,206,241z';
                  }
                  
                  
                  
					if (typeof nashville !== 'undefined') {
						var nashvilleLines = 'M228,186H73v-1h155V186z M228,187H73v1h155V187z M228,189H73v1h155V189z M228,191H73v1h155V191z M228,193H73v1h155V193z M228,195H73v1h155V195z';
						nashvilleLines = Raphael.transformPath(nashvilleLines, 't0, -25, s1.2, 1.2');

						outerPath += nashvilleLines;
						innerPath += nashvilleLines;
					}

					if (typeof bcLions !== 'undefined') {
						var bcLionsLines = 'M139.1,175.7c0,0.2,0,0.4,0,0.6h33.4c0-0.2,0-0.4,0.1-0.6H139.1zM139.1,179.7c0,0.5,0,0.9,0,1.3H172c0.1-0.4,0.1-0.9,0.2-1.3H139.1zM132.3,183.6c0-0.7,0-1.3,0-2H99.8c0.1,0.7,0.2,1.3,0.2,2H132.3zM139.2,181.6c0,0.7,0,1.4,0,2h32.5c0.1-0.7,0.2-1.3,0.2-2H139.2zM139.1,177.9c0,0.3,0,0.6,0,0.9h33.1c0-0.3,0.1-0.6,0.1-0.9H139.1zM132.3,181.1c0-0.4,0-0.9,0-1.3H99.6c0.1,0.5,0.1,0.9,0.2,1.3H132.3zM132.2,178.8c0-0.3,0-0.6,0-0.9H99.4c0,0.3,0.1,0.6,0.1,0.9H132.2zM139.2,184c0,3,0,5.7,0.1,8.1h31.3c0.3-2.6,0.7-5.3,1-8.1H139.2zM132.3,184h-32.2c0.3,2.8,0.6,5.6,0.9,8.1h31.4C132.3,189.7,132.3,187,132.3,184zM132.2,173.7c0-0.1,0-0.2,0-0.3H98.9c0,0.1,0,0.2,0,0.3H132.2zM139.1,173.5c0,0.1,0,0.2,0,0.3h33.7c0-0.1,0-0.2,0-0.3H139.1zM132.2,176.3c0-0.2,0-0.4,0-0.6H99.2c0,0.2,0,0.4,0.1,0.6H132.2zM178.8,176.3H206v-0.6h-27.1C178.9,175.9,178.8,176.1,178.8,176.3zM177.8,183.6H206v-2h-27.9C178,182.3,177.9,183,177.8,183.6zM176.8,192.1H206V184h-28.2C177.4,186.9,177.1,189.6,176.8,192.1zM178.2,181.1H206v-1.3h-27.6C178.3,180.2,178.2,180.6,178.2,181.1zM178.5,178.8H206v-0.9h-27.4C178.6,178.2,178.5,178.5,178.5,178.8zM179.2,173.7H206v-0.3h-26.8C179.2,173.6,179.2,173.6,179.2,173.7zM93.8,177.9H69v0.9h24.9C93.8,178.5,93.8,178.2,93.8,177.9zM94.5,184H69v8.1h26.5C95.2,189.6,94.9,186.9,94.5,184zM93.2,173.5H69v0.3h24.2C93.2,173.6,93.2,173.6,93.2,173.5zM93.5,175.7H69v0.6h24.6C93.5,176.1,93.5,175.9,93.5,175.7zM94,179.7H69v1.3h25.2C94.1,180.6,94,180.2,94,179.7zM94.2,181.6H69v2h25.5C94.4,183,94.3,182.3,94.2,181.6z';

						bcLionsLines = Raphael.transformPath(bcLionsLines, 't0.2, 0, s0.98, 1.1');
						defs.appendChild(svgClipPathCreator('clip-path-bc-lions', bcLionsLines));
					}


					if (typeof referee !== 'undefined') {
						outerPath = 'M82.3,51h51.2l-0.2,56H88.7L82.3,51z M137.2,51l-0.2,56h43.9l6.9-56H137.2z';
						innerPath = 'M82.3,51h51.2l-0.2,56H88.7L82.3,51z M137.2,51l-0.2,56h43.9l6.9-56H137.2z';
					}


					defs.appendChild(svgClipPathCreator('clip-path-outer', outerPath));

					defs.appendChild(svgClipPathCreator('clip-path-inner', innerPath));

					$('#svg-canvas svg').prepend(defs);
				}
			}

			function svgClipPathCreator(id_To_Use, path_To_Use) {
				var clipPath = document.createElementNS("http://www.w3.org/2000/svg", 'clipPath');
				var path = document.createElementNS("http://www.w3.org/2000/svg", 'path');
				var path_Data = path_To_Use;
				path.setAttributeNS(null, 'd', path_Data);
				clipPath.id = id_To_Use;
				clipPath.appendChild(path);
				return clipPath;
			}

			function createClipPath() {

				var defs2= document.createElementNS("http://www.w3.org/2000/svg", 'defs');

				var clipPath2 = document.createElementNS("http://www.w3.org/2000/svg", 'clipPath');
              	
              
              	var col_data = $(inputcoltype_Selector).val();
                if (col_data == 'Tri Layer Technology Custom with personalized name and number Chair'){
                    
                    var polygon2 = document.createElementNS("http://www.w3.org/2000/svg", 'polygon');
                    polygon2.setAttributeNS(null, 'points', "52,230 200,230 200,285 52,285 ");
					
                  	clipPath2.id = 'clip-path';
                    clipPath2.appendChild(polygon2);
                    
                }else{
                  
                  	var polygon1 = document.createElementNS("http://www.w3.org/2000/svg", 'polygon');
                	polygon1.setAttributeNS(null, 'points', "83.2,96 79.7,70 34.7,70 41,96 ");

                	var polygon2 = document.createElementNS("http://www.w3.org/2000/svg", 'polygon');
                	polygon2.setAttributeNS(null, 'points', "132.6,96 132.3,70 85.6,70 89.3,96 ");

                	var polygon3 = document.createElementNS("http://www.w3.org/2000/svg", 'polygon');
                	polygon3.setAttributeNS(null, 'points', "182.5,96 185.9,70 140,70 139.4,96 ");

                	var polygon4 = document.createElementNS("http://www.w3.org/2000/svg", 'polygon');
                	polygon4.setAttributeNS(null, 'points', "229.5,96.2 235.8,70.3 192.9,70 189,96 ");
                		clipPath2.id = 'clip-path';
                        clipPath2.appendChild(polygon1);
                        clipPath2.appendChild(polygon2);
                        clipPath2.appendChild(polygon3);
                        clipPath2.appendChild(polygon4);

                }
			
				defs2.appendChild(clipPath2);

				$('#svg-canvas svg').prepend(defs2);
			}

			var input_Selector = '#custom-name',
				inputNumber_Selector = '#custom-number',
				inputcoltype_Selector = '#collection-type';

			var storage = {
				name: '',
				number: ''
			};

			setInterval(function() {
				//fix ios change input bug
				if (storage.name !== $(input_Selector).val()) {
					updateTextInput(input_Selector);
				}

				if (storage.number !== $(inputNumber_Selector).val()) {
					updateNumberInput(inputNumber_Selector);
				}
			}, 1000);

			function updateTextInput(input_this) {
				if (!$(input_this).val()) return;
				try {
					if ($(input_this).val().match(/[0-9]/g, '')) {
						$(input_this).val( $(input_this).val().replace(/[0-9]/g, '') );
					}
				} catch(e) {}

				if (storage.name !== $(input_this).val()) {
					activeFunction();
					storage.name = $(input_this).val();
				}
			}

			function updateNumberInput(input_this) {
				if ($(input_this).val().match(/'/g, '') || $(input_this).val().match(/\./g, '')) {
					$(input_this).val( $(input_this).val().replace(/'/g, '').replace(/\./g, '') );
				}

				if (storage.number !== $(input_this).val()) {
					activeFunction();
					storage.number = $(input_this).val();
				}
			}

			$(input_Selector).on('keydown', function(e) {
				var letThis = this;
				updateTextInput(letThis);
			});


			$(inputNumber_Selector).on('keydown', function(e) {
				var self = this;
				updateNumberInput(self);
			});

			$('#small-caps-toggle').on('change', function() {
				activeFunction();
			});

			// Getting input value from chosen selector, and making sure its a uppercase string
			function getInputValue() {
				var result = '';

				if ($(input_Selector).val()) {
					result = $(input_Selector).val().toString();
				}

				if (!document.getElementById('small-caps-toggle').checked) {
					result = result.toUpperCase();
				}

				return result;
			}

			function getNumberValue() {
				var result = $(inputNumber_Selector).val().toString();
              	
              	
              
				return result;
			}

			// Svg generator
			if ($('#svg-canvas image').length) {
				$('#svg-canvas').contents().remove();
			}

			var svg_Width = 269,
				svg_Height = 370,
				svg_Canvas = svg_Canvas || new Raphael(document.getElementById('svg-canvas'), svg_Width, svg_Height),
				characterObject = {};
//alert(JSON.stringify(svg_Canvas));
			// Sets the svg attributes
			svg_Canvas.setViewBox(0, 0, svg_Width, svg_Height);
			svg_Canvas.canvas.setAttribute('id', 'current-svg-canvas');

			function createSmallCaps() {
				var fontKeys = Object.keys(font);
				for (var i = 0, l = fontKeys.length; l > i; i++) {
					var fontKey = fontKeys[i];
					if (fontKey !== '.' || fontKey !== '-' || fontKey !== "'") {
						font[ fontKey.toLowerCase() ] = Raphael.transformPath(font[ fontKey ], 't'+ (small_Caps_Adjustment.horizontal) +', '+(svg_Width + small_Caps_Adjustment.vertical) +' s'+ (0.6875 + small_Caps_Adjustment.scale_width) +', '+ (0.6875 + small_Caps_Adjustment.scale_height));
					}
				}
			}

			createSmallCaps();
			font[' '] = font.I;

			function correctFont() {

				if (typeof fontFile !== 'undefined') return;

				var el = Object.keys(font),
					el_l = el.length,
					units_per_em = 2048,
					mod = 0;

				for (var i = 0; el_l > i; i++) {
					var el_i = el[i],
						test_Height = Raphael.pathBBox(font[el_i]).height/units_per_em * font_size,
						hor_Mod = 0;


					if (font_size !== test_Height) {
						if (el_i !== '.') {
							mod = font_size - test_Height;
						}
					} else {
						mod = 0;
					}

					var ver_Mod = (font_size + mod + 0.2);
					var scaleByWidth = (font_size + mod)/units_per_em;
					var scaleByHeight = (font_size + mod)/units_per_em;

					if (el_i === 'q' ||
						el_i === 'Q') {
						ver_Mod += 1;
						if (typeof Q_offset !== 'undefined') {
							ver_Mod += Q_offset.vertical;
							scaleByHeight = (font_size + (font_size - test_Height) + Q_offset.height)/units_per_em;
							scaleByWidth = (font_size + mod + Q_offset.height)/units_per_em;
						} else {
							scaleByHeight = (font_size + (font_size - test_Height))/units_per_em;
						}
					}

					if (typeof ottawaRedBlacks !== 'undefined') {
						if (el_i === 'o' ||
							el_i === 'O' ||
							el_i === 'u' ||
							el_i === 'U') {
							ver_Mod += 0.25;
						}
					}

					if (font_Top_Adjustment) {
						ver_Mod += font_Top_Adjustment;
					}
					// this needs better auto correction

					var sCharAd = special_Character_Adjustments;
					if (el_i === '.') {
						ver_Mod = (font_size - sCharAd.period.vertical);
						scaleByWidth = (font_size + sCharAd.period.scale_width)/units_per_em;
						scaleByHeight = (font_size + sCharAd.period.scale_height)/units_per_em;
						hor_Mod = sCharAd.period.horizontal;
					}

					if (el_i === "'") {
						scaleByWidth = (font_size + mod + sCharAd.apostrophe.scale_width)/units_per_em;
						scaleByHeight = (font_size + mod +  sCharAd.apostrophe.scale_height)/units_per_em;
						ver_Mod = (font_size + mod + sCharAd.apostrophe.vertical);
						hor_Mod = sCharAd.apostrophe.horizontal;
					}

					if (el_i === '-') {
						scaleByWidth = (font_size + mod + sCharAd.hyphen.scale_width)/units_per_em;
						scaleByHeight = (font_size + mod +  sCharAd.hyphen.scale_height)/units_per_em;
						ver_Mod = (font_size - sCharAd.hyphen.vertical);
						hor_Mod = sCharAd.hyphen.horizontal;
					}

					font[el_i] = Raphael.transformPath(font[el_i], 't '+ hor_Mod +', '+ ver_Mod +', s'+ scaleByWidth +', -'+ scaleByHeight +', 0, 0');
				}
			}

			correctFont();

			// Letter Svg
			if ($('#svg-letter svg').length) {
				$('#svg-letter').contents().remove();
			}

			var letter_Canvas = new Raphael(
				document.getElementById('svg-letter'),
				letterAdjust.svg.width,
				letterAdjust.svg.height
			);

			$('#letter-c, #letter-a, #letter-none').on('change', function() {
				activeFunction();
			});

			function letterChoice() {
				var result,
					triggerC = document.getElementById('letter-c'),
					triggerA = document.getElementById('letter-a');

				if (triggerC.checked) {
					result = 'C';
				} else if (triggerA.checked) {
					result = 'A';
				} else {
					result = ' ';
				}

				return result;
			}

			// Fixes images not loading on mobile, and not trying to load after
			var keepTryingCount = 0,
				keepTryingInterval = setInterval(function() {
					keepTryingCount++;
					if (keepTryingCount > 10) {
						clearInterval(keepTryingInterval);
					} else {
						$('.productImages.productImage--real').each(function(i, el) {
							if (el.src.indexOf('no-image') !== -1) {
								activeFunction();
							} else {
								clearInterval(keepTryingInterval);
							}
						});
					}
				}, 1000);


			function activeFunction() {
				svg_Canvas.clear();
				var imgSrc = imageSourceResult;

				$('.js-remove-this').each(function() {
					$(this).remove();
				});

				var background_Image = svg_Canvas.image(imgSrc, 0, 0, svg_Width, svg_Height);

				state = {
					tolerance: state.tolerance,
					zero_Approx: state.zero_Approx,
					svg: {
						height: state.svg.height,
					},
					panels: {
						width: state.panels.width,
					},
				};

				characterObject = createCharacterObject();

				if (typeof referee === 'undefined') {
					drawCharacters();
				}

				drawNumbers();
				createClipPath();

				// console.log(state);

				letter_Canvas.clear();

				// letter adjust
				if (typeof phil !== 'undefined') {
					paintSvg({
						path: Raphael.transformPath(font[letterChoice()],
						 't'+letterAdjust.x+','+letterAdjust.y + 's' + letterAdjust.scale + ',' + letterAdjust.scale),
						color: colors.numbers.home,
						stroke_Width: 1.5,
						character: letterChoice(),
					}, true);
				} else if (typeof st_louis !== 'undefined') {
					paintSvg({
						path: Raphael.transformPath(font[letterChoice()],
						 't'+letterAdjust.x+','+letterAdjust.y + 's' + letterAdjust.scale + ',' + letterAdjust.scale),
						color: current_Color_Numbers,
						stroke_Width: 1.5,
						character: letterChoice(),
					}, true);
				} else if (letterAdjust.use_number_outline) {
					paintSvg({
						path: Raphael.transformPath(font[letterChoice()],
						 't'+letterAdjust.x+','+letterAdjust.y + 's' + letterAdjust.scale + ',' + letterAdjust.scale),
						color: current_Color_Numbers,
						stroke_Width: 1.5,
						character: letterChoice(),
					}, true);
				} else {
					paintSvg({
						path: Raphael.transformPath(font[letterChoice()],
						 't'+letterAdjust.x+','+letterAdjust.y + 's' + letterAdjust.scale + ',' + letterAdjust.scale),
						color: current_Color,
						stroke_Width: outlines.characters.width,
						character: letterChoice(),
					}, true);
				}

				background_Image.toBack();
				svg_Canvas.safari();
			}

			$('#svg-letter').css({
				position: 'absolute',
				top: letterAdjust.svg.top + '%',
				left: letterAdjust.svg.left
				

			});

			if (imageSourceResult.indexOf('Molson') !== -1) {
				chooseColor('White');
			}

			else if (typeof referee !== 'undefined') {
				chooseColor('Referee');
			} else {
				var homeString = 'Home';
				if (typeof homeStringChange !== 'undefined') homeString = capitalizeString(homeStringChange);
				chooseColor(homeString);
			}
      $('.swatch-element [name="option-0"]').each(function() {
        $(this).click();
      });

			chooseColor(first_Color_Choice);
// 			chooseColor( $('.swatch__container > .swatch > [data-value]:first-of-type ').attr('data-value') );

			$('.productImages.productImage--front').parent().addClass('productImage--front__parent');


			// Helper function, not being used yet
			function svg_SkewX(element, angle, x, y) {
          
				var svg = document.getElementById('current-svg-canvas'),
					box = element.getBBox();
	//alert('hello');
				x = x * box.width + box.x;
				y = y * box.height + box.y;

				var matrix = svg.createSVGMatrix().translate(x, y).skewX(angle).translate(-x, -y);
				element.transform(Raphael.matrix(matrix.a, matrix.b, matrix.c, matrix.d, matrix.e, matrix.f).toTransformString());
			}
		}

		// getFont(_fontFileText, _fontFileNumbers, _fontFileName);
		// function getFont(fontFileToUse, fontFileForNumbersToUse, fontFileName) {
		// 	opentype.load(fontFileToUse, function(err, _font) {
		// 		var font_output = {};


		// 		"abcdefghijklmnopqrstuvwxyz.".toUpperCase().split('').map(function(character) {
		// 			var transformPathAdjustment = 't'+ (-1) + ',' + (15);
		// 			font_output[character] = Raphael.transformPath(
		// 				_font.getPath(character, 0, 0, 24).toPathData(3),
		// 				transformPathAdjustment
		// 			);
		// 		});

		// 		var fontFileForNumbers;

		// 		if (fontFileForNumbersToUse) {
		// 			fontFileForNumbers = fontFileForNumbersToUse;
		// 		} else {
		// 			fontFileForNumbers = fontFileToUse;
		// 		}

		// 		opentype.load(fontFileForNumbers, function(err, _font) {
		// 			"1234567890".split('').map(function(character) {
		// 				var transformPathAdjustment = 't'+ (0) + ',' + (35);
		// 				font_output[character] = Raphael.transformPath(
		// 					_font.getPath(character, 0, 0, 24).toPathData(3),
		// 					transformPathAdjustment
		// 				);
		// 			});
		// 			fontLoadedCallback(font_output);

		// 			var saveData = (function () {
		// 				var a = document.createElement("a");
		// 				document.body.appendChild(a);
		// 				a.style = "display: none";

		// 				return function (data, fileName) {
		// 					var json = JSON.stringify(data),
		// 						blob = new Blob([json], {type: "octet/stream"}),
		// 						url = window.URL.createObjectURL(blob);

		// 					a.href = url;
		// 					a.download = fileName;
		// 					a.click();
		// 					window.URL.revokeObjectURL(url);
		// 				};
		// 			}());

		// 			var data = font_output,
		// 				fileName = fontFileName;

		// 			saveData(data, fileName);

		// 		});
		// 	});
		// }

		if (typeof fontAlt !== 'undefined') {
			$('.swatch-element.athletic').click(function(e) {
				$('#svg-canvas').hide();
				$('#loading-animation-container').removeClass('hidden');
				location.reload();
			});

			var firstClick;
			$('.swatch-element.academic').click(function(e) {
				if (!firstClick) {
					firstClick = true;
				} else {
					if ($('.swatch-element.academic input:checked').length) {
						$('#svg-canvas').hide();
						$('#loading-animation-container').removeClass('hidden');
						location.reload();
					}
				}
			});

			var storeFont = font;
			window.athleticIsActive = true;
			window.academicIsActive = false;
			window.numberTransformPathRegularFireTwice = [];
			window.numberTransformPathAltFireTwice = [];

			mapObjectKeys(regularFontProps, window, fontLoadedCallback, storeFont);

			if (academicIsActive) {
				$('.swatch-element.athletic').click(function() {
					window.athleticIsActive = true;
					window.academicIsActive = false;
					mapObjectKeys(regularFontProps, window, fontLoadedCallback, storeFont);
				});
			}

			if (athleticIsActive) {
				$('.swatch-element.academic').click(function() {
					window.athleticIsActive = false;
					window.academicIsActive = true;
					mapObjectKeys(altFontProps, window, fontLoadedCallback, fontAlt);
				});
			}
		} else {
			fontLoadedCallback();
		}
		// } else {
		// 	if (typeof fontFileNumbers !== 'undefined') {
		// 		getFont(fontFile, fontFileNumbers);
		// 	} else if (typeof fontFile !== 'undefined') {
		// 		getFont(fontFile);
		// 	} else {
		// 	}
		// }

	});
}

//--------------NFL/MLB CUSTOM JERSEY--------------//
//
//------------------functions------------------//
/**
 * Generate font based on meta tag and home/away/light/grey/dark
 * Other Custom Jursey options brown=beige/powderblue
 * @return {Object}
 */
function generateFont() {

	var team = $('head').find('.team-name').attr('content'),
			color = '';

	if ($('.retro input').attr('checked')) {
		color = 'retro';
	} else if($('.away input').attr('checked')) {
		color = 'away';
	} else if ($('.home input').attr('checked')) {
		color = 'home';
	} else if ($('.dark input').attr('checked')) {
		color = 'dark';
	} else if ($('.light input').attr('checked')) {
		color = 'light';
	}else if ($('.alternate input').attr('checked')) {
		color = 'alternate';
	}else if ($('.grey input').attr('checked')) {
		color = 'grey';
// 	} else if ($('.brown input').attr('checked')) {
// 		color = 'brown';
	}  else if ($('.beige input').attr('checked')) {
		color = 'beige';
	} else if ($('.powder input').attr('checked')) {
		color = 'powder';
	} else if ($('.navy input').attr('checked')) {
		color = 'navy';
	} else if ($('.orange input').attr('checked')) {
		color = 'orange';
	} else if ($('.royal input').attr('checked')) {
		color = 'royal';
	}else if ($('.extra input').attr('checked')) {
		color = 'extra';
	} 
  
  	

	var nflFont = {
	  "0": "nflicon-"+ team +"_"+ color +"_0",
	  "1": "nflicon-"+ team +"_"+ color +"_1",
	  "2": "nflicon-"+ team +"_"+ color +"_2",
	  "3": "nflicon-"+ team +"_"+ color +"_3",
	  "4": "nflicon-"+ team +"_"+ color +"_4",
	  "5": "nflicon-"+ team +"_"+ color +"_5",
	  "6": "nflicon-"+ team +"_"+ color +"_6",
	  "7": "nflicon-"+ team +"_"+ color +"_7",
	  "8": "nflicon-"+ team +"_"+ color +"_8",
	  "9": "nflicon-"+ team +"_"+ color +"_9",
	  "a": "nflicon-"+ team +"_"+ color +"_a",
	  "b": "nflicon-"+ team +"_"+ color +"_b",
	  "c": "nflicon-"+ team +"_"+ color +"_c",
	  "d": "nflicon-"+ team +"_"+ color +"_d",
	  "e": "nflicon-"+ team +"_"+ color +"_e",
	  "f": "nflicon-"+ team +"_"+ color +"_f",
	  "g": "nflicon-"+ team +"_"+ color +"_g",
	  "h": "nflicon-"+ team +"_"+ color +"_h",
	  "i": "nflicon-"+ team +"_"+ color +"_i",
	  "j": "nflicon-"+ team +"_"+ color +"_j",
	  "k": "nflicon-"+ team +"_"+ color +"_k",
	  "l": "nflicon-"+ team +"_"+ color +"_l",
	  "m": "nflicon-"+ team +"_"+ color +"_m",
	  "n": "nflicon-"+ team +"_"+ color +"_n",
	  "o": "nflicon-"+ team +"_"+ color +"_o",
	  "p": "nflicon-"+ team +"_"+ color +"_p",
	  "q": "nflicon-"+ team +"_"+ color +"_q",
	  "r": "nflicon-"+ team +"_"+ color +"_r",
	  "s": "nflicon-"+ team +"_"+ color +"_s",
	  "t": "nflicon-"+ team +"_"+ color +"_t",
	  "u": "nflicon-"+ team +"_"+ color +"_u",
	  "v": "nflicon-"+ team +"_"+ color +"_v",
	  "w": "nflicon-"+ team +"_"+ color +"_w",
	  "x": "nflicon-"+ team +"_"+ color +"_x",
	  "y": "nflicon-"+ team +"_"+ color +"_y",
      "z": "nflicon-"+ team +"_"+ color +"_z",
	  "'": "M360,1638h311l0-648H360L360,1638z",
	  "captain_c": "nflicon-"+ team +"_"+ color +"_small_c"
	}

	return nflFont;
}

/**
 * [setLetters] based on letter array and font object
 * @param {array} [letterArray] letters split into array
 * @param {object} [fontObject] object with font references
 */
function setLetters(letterArray, fontObject){

	var $letters = $('#Letters'),
			$container = $('.my-custom-sports-chair__app'),
			team = $('head').find('.team-name').attr('content'),
			gapMarginOuter = '',
			gapMarginInner = '',
			middle = '',
			offset = '',
			outerPositioning = {},
			middlePositioning = {};

	//start with empty container
	$letters.empty();

	//get letter positions
	outerPositioning = letterPositioning(team, letterArray.length);
	
	//assign positions to local variables
	gapMarginOuter = outerPositioning.outer;
	gapMarginInner = outerPositioning.inner;
	regMargin = outerPositioning.reg;

	//test for middle letter
	if (letterArray.length % 2 != 0) {
		//find index of middle if odd
		middle = Math.floor((letterArray.length - 1) / 2);
	} else {
		//idnex for letter left og center if no middle letter
		offset = Math.floor(letterArray.length / 2);
	}

	//loop through letters and compare to font object--
	//--to get classes for letters
	for (var i = 0; i < letterArray.length; i++) {
		$.each(fontObject, function(key, value){
		  if (letterArray[i].toLowerCase() == key) {

		  	//isolate middle letter
		  	if (typeof middle !== 'undefined'
		  			&& i == middle
		  			&& i != 0
		  			&& i != 12) {

		  		//get middle positions
		  		middlePositioning = middleLetterPositioning(key, team);

		  		$letters.append('<span class="'+ fontObject[key] +' '+team+' custom-letter" style="'+middlePositioning.marginFirst+'"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span><span class="path25"></span></span>');
		  		$letters.append('<span class="'+ fontObject[key] +' '+team+' custom-letter" style="'+middlePositioning.marginLast+'"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span><span class="path25"></span></span>');

		  	} else if(letterArray.length == 7 && i != middle){

		  		$letters.append('<span class="'+ fontObject[key] +' '+team+' custom-letter" style="'+regMargin+'"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span><span class="path25"></span></span>');

		  	} else if(letterArray.length == 8 && i == 0
		  			|| letterArray.length == 8 && i == 6){

		  		$letters.append('<span class="'+ fontObject[key] +' '+team+' custom-letter" style="'+gapMarginOuter+'"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span><span class="path25"></span></span>');

		  	} else if(letterArray.length == 9 && i == 0
		  			|| letterArray.length == 9 && i == 7){

		  		$letters.append('<span class="'+ fontObject[key] +' '+team+' custom-letter" style="'+gapMarginOuter+'"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span><span class="path25"></span></span>');

		  	} else if(letterArray.length == 10 && i == 1
		  			|| letterArray.length == 10 && i == 7){

		  		$letters.append('<span class="'+ fontObject[key] +' '+team+' custom-letter" style="'+gapMarginOuter+'"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span><span class="path25"></span></span>');

		  	} else if(letterArray.length == 11 && i == 1
		  			|| letterArray.length == 11 && i == 8){

		  		$letters.append('<span class="'+ fontObject[key] +' '+team+' custom-letter" style="'+gapMarginOuter+'"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span><span class="path25"></span></span>');

		  	} else if(letterArray.length == 12 && i == 2
		  			|| letterArray.length == 12 && i == 8){

		  		$letters.append('<span class="'+ fontObject[key] +' '+team+' custom-letter" style="'+gapMarginOuter+'"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span><span class="path25"></span></span>');

		  	} else if(i == offset - 1){
		  		//set middle margin if no middle letter
		  		$letters.append('<span class="'+ fontObject[key] +' '+team+' custom-letter" style="'+gapMarginInner+'"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span><span class="path25"></span></span>');

		  	} else if(letterArray.length == 12 && i != 2  && i != 8){
		  		//reduce margin to 1 when full
		  		$letters.append('<span class="'+ fontObject[key] +' '+team+' custom-letter" style="margin: 0 1px"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span><span class="path25"></span></span>');

		  	} else {

		  		$letters.append('<span class="'+ fontObject[key] +' '+team+' custom-letter" style="'+regMargin+'"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span><span class="path25"></span></span>');

		  	}
			}
		});
	}

	//adjust left css value to center letters

	var letterWidth = $letters.width();
	var parentWidth = $container.width();
	var leftValue = (parseInt(parentWidth - letterWidth)) / 2;
	$letters.css('left', leftValue);
}

/**
 * [middleLetterPositioning] middle letter positions
 * @param  {string} letter: current middle letter
 * @param  {string} team:   current team
 * @return {object} marginFirst,marginLast
 */
function middleLetterPositioning(letter, team) {

	var position = {
		"marginFirst": "",
		"marginLast": ""
	};
	//console.log(team);
	if (letter == 'i') {
		position.marginLast = 'margin: 0 4px 0 -8px';
		position.marginFirst = 'margin: 0 5px';
	} else if (letter == 't'){
		position.marginLast = 'margin: 0 2px 0 -6px';
		position.marginFirst = 'margin: 0 2px';
	} else if(letter == 'w'){
		position.marginLast = 'margin: 0 4px 0 -11px';
		position.marginFirst = 'margin: 0 5px';
	}  else if(letter == 'a'){
		position.marginLast = 'margin: 0 4px 0 -11px';
		position.marginFirst = 'margin: 0 5px';
	} else if(letter == 'o' && team == 'jets'){
		position.marginLast = 'margin: 0 2px 0 -10px';
		position.marginFirst = 'margin: 0 8px 0 5px';
	} else if(letter == 'o' && team == 'browns'){
		position.marginLast = 'margin: 0 2px 0 -11px';
		position.marginFirst = 'margin: 0 9px 0 4px';
	} else if(letter == 'o' && team == 'texans'){
		position.marginLast = 'margin: 0 2px 0 -11px';
		position.marginFirst = 'margin: 0 7px 0 5px';
	} else if(letter == 'o' && team == 'patriots'){
		position.marginLast = 'margin: 0 2px 0 -11px';
		position.marginFirst = 'margin: 0 7px 0 4px';
	} else if(letter == 'o' && team == 'raiders'){
		position.marginLast = 'margin: 0 2px 0 -11px';
		position.marginFirst = 'margin: 0 9px 0 3px';
	} else if(letter == 'o' && team == 'chargers'){
		position.marginLast = 'margin: 0 2px 0 -11px';
		position.marginFirst = 'margin: 0 7px 0 4px';
	} else if(letter == 'o' && team == 'cowboys'){
		position.marginLast = 'margin: 0 5px 0 -10px';
		position.marginFirst = 'margin: 0 7px 0 7px';
	} else if(letter == 'o' && team == 'lions'){
		position.marginLast = 'margin: 0 2px 0 -11px';
		position.marginFirst = 'margin: 0 7px 0 4px';
	} else if(letter == 'o' && team == 'vikings'){
		position.marginLast = 'margin: 0 2px 0 -11px';
		position.marginFirst = 'margin: 0 7px 0 4px';
	} else if(letter == 'o' && team == 'giants'){
		position.marginLast = 'margin: 0 4px 0 -11px';
		position.marginFirst = 'margin: 0 7px 0 4px';
	} else if(letter == 'o' && team == 'eagles'){
		position.marginLast = 'margin: 0 2px 0 -11px';
		position.marginFirst = 'margin: 0 8px 0 5px';
	} else if(letter == 'o' && team == '49ers'){
		position.marginLast = 'margin: 0 6px 0 -10px';
		position.marginFirst = 'margin: 0 7px 0 7px';
	} else if(letter == 'o' && team == 'seahawks'){
		position.marginLast = 'margin: 0 6px 0 -11px';
		position.marginFirst = 'margin: 0 11px 0 7px';
	} else {
		position.marginLast = 'margin: 0 2px 0 -11px';
		position.marginFirst = 'margin: 0 7px 0 3px';
	}
	return position;
}

/**
 * [teamPositining] gap positioning for letters
 * @param  {string} the nfl team name as string
 * @return {object} contains inner and outer margins for gaps
 */
function letterPositioning(team, length) {

	var position = {
		"outer": "",
		"inner": "",
		"reg": "margin: 0 1px"
	}

	var windowWidth = $(window).width(),
			baseLeft = '2px';
	//console.log(length);
	if (length == 12 || length == 11) {
		baseLeft = '1px';
	} else if(length == 7){
		baseLeft = '0';
	}
	/*
	if (length == 9 || length == 11) {
		position.reg = 'margin: 0 0';
	}
	*/
	if (team == "49ers") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 1px';
		} else if(length == 9){

			position.outer = 'margin: 0 7px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 12px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;
		}

	} else if (team == "bears") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 17px 0 '+baseLeft;
			position.inner = 'margin: 0 12px 0 '+baseLeft;
		}

	} else if (team == "bengals") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 14px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;
		}
	} else if (team == "astros" || team == "athletics" || team == "angels" || team == "braves" ||
              team == "cubs" || team == "dodgers" || team == "jays" || team == "indians" || 
              team == "mets" || team == "padres" || team == "orioles" || team == "rays" || 
              team == "phillies" || team == "redsox" || team == "royals" || team == "yankees" ||
              team == "brewers" || team == "twins" || team == "tigers" || team == "rockies" || 
              team == "reds" || team == "rangers" || team == "diamondbacks" || team == "marlins" ||
              team == "pirates" || team == "nationals" || team == "mariners" || team == "giants" ||
              team == "cards" || team == "whitesox") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 14px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;
		}

	
	} else if (team == "bills") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 16px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;
			position.reg = 'margin: 0 1px';

		} else if(length == 11){

			position.outer = 'margin: 0 18px 0 '+baseLeft;
			position.inner = 'margin: 0 13px 0 '+baseLeft;
			position.reg = 'margin: 0 1px';

		} else if(length == 12){

			position.outer = 'margin: 0 18px 0 '+baseLeft;
			position.inner = 'margin: 0 16px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 18px 0 '+baseLeft;
			position.inner = 'margin: 0 14px 0 '+baseLeft;
		}

	} else if (team == "broncos") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 16px 0 '+baseLeft;
			position.inner = 'margin: 0 15px 0 '+baseLeft;
		}

	} else if (team == "browns") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 16px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;
		}

	} else if (team == "buccaneers") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 12px 0 '+baseLeft;
			position.inner = 'margin: 0 11px 0 '+baseLeft;
		}

	} else if (team == "cardinals") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 11px 0 '+baseLeft;
			position.inner = 'margin: 0 11px 0 '+baseLeft;
		}

	} else if (team == "chargers") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 16px 0 '+baseLeft;
			position.inner = 'margin: 0 11px 0 '+baseLeft;
		}

	} else if (team == "chiefs") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 16px 0 '+baseLeft;
			position.inner = 'margin: 0 11px 0 '+baseLeft;
		}

	} else if (team == "colts") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 18px 0 '+baseLeft;
			position.inner = 'margin: 0 14px 0 '+baseLeft;
		}

	} else if (team == "cowboys") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 14px 0 '+baseLeft;
			position.inner = 'margin: 0 11px 0 '+baseLeft;
		}

	} else if (team == "dolphins") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){
			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;
		} else {
			position.outer = 'margin: 0 12px 0 '+baseLeft;
			position.inner = 'margin: 0 10px 0 '+baseLeft;
		}

	} else if (team == "eagles") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 7){
			position.reg = 'margin: 0 0';
		}  else if(length == 8){
			position.outer = 'margin: 0 11px 0 '+baseLeft;
			position.inner = 'margin: 0 7px 0 '+baseLeft;
			position.reg = 'margin: 0 0';
		}  else if(length == 9){
			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 7px 0 '+baseLeft;
			position.reg = 'margin: 0 0';
		} else {
			position.outer = 'margin: 0 11px 0 '+baseLeft;
			position.inner = 'margin: 0 7px 0 '+baseLeft;
		}

	} else if (team == "falcons") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){
			position.outer = 'margin: 0 15px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;
		} else {
			position.outer = 'margin: 0 15px 0 '+baseLeft;
			position.inner = 'margin: 0 10px 0 '+baseLeft;
		}

	} else if (team == "jaguars") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){
			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;
		} else {
			position.outer = 'margin: 0 15px 0 '+baseLeft;
			position.inner = 'margin: 0 11px 0 '+baseLeft;
		}

	} else if (team == "lions") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){
			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;
		} else {
			position.outer = 'margin: 0 14px 0 '+baseLeft;
			position.inner = 'margin: 0 11px 0 '+baseLeft;
		}

	} else if (team == "giants") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){
			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;
		} else {
			position.outer = 'margin: 0 16px 0 '+baseLeft;
			position.inner = 'margin: 0 11px 0 '+baseLeft;
		}

	} else if (team == "jets") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){
			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;
		} else {
			position.outer = 'margin: 0 16px 0 '+baseLeft;
			position.inner = 'margin: 0 11px 0 '+baseLeft;
		}

	} else if (team == "packers") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){
			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;
		} else {
			position.outer = 'margin: 0 16px 0 '+baseLeft;
			position.inner = 'margin: 0 11px 0 '+baseLeft;
		}

	} else if (team == "panthers") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){
			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;
			position.reg = 'margin: 0 1px';

		} else {
			position.outer = 'margin: 0 17px 0 '+baseLeft;
			position.inner = 'margin: 0 11px 0 '+baseLeft;
		}

	} else if (team == "patriots") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){
			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;
		} else {
			position.outer = 'margin: 0 12px 0 '+baseLeft;
			position.inner = 'margin: 0 11px 0 '+baseLeft;
		}

	} else if (team == "raiders") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 16px 0 '+baseLeft;
			position.inner = 'margin: 0 11px 0 '+baseLeft;
		}

	} else if (team == "rams") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 10px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 16px 0 '+baseLeft;
			position.inner = 'margin: 0 11px 0 '+baseLeft;
		}

	} else if (team == "ravens") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';

		} else if(length == 9){

			position.outer = 'margin: 0 11px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else if(length == 12){

			position.outer = 'margin: 0 13px 0 '+baseLeft;
			position.inner = 'margin: 0 18px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 13px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;
		}

	} else if (team == "redskins") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 7px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 18px 0 '+baseLeft;
			position.inner = 'margin: 0 11px 0 '+baseLeft;
		}

	} else if (team == "saints") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 7px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 15px 0 '+baseLeft;
			position.inner = 'margin: 0 15px 0 '+baseLeft;
		}

	} else if (team == "seahawks") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 7px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 12px 0 '+baseLeft;
			position.inner = 'margin: 0 15px 0 '+baseLeft;
		}

	} else if (team == "steelers") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 7px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 15px 0 '+baseLeft;
			position.inner = 'margin: 0 15px 0 '+baseLeft;
		}

	} else if (team == "texans") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 7px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 16px 0 '+baseLeft;
			position.inner = 'margin: 0 15px 0 '+baseLeft;
		}

	} else if (team == "titans") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 7px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 16px 0 '+baseLeft;
			position.inner = 'margin: 0 15px 0 '+baseLeft;
		}

	} else if (team == "vikings") {

		if (windowWidth > 769 && windowWidth < 993) {
			position.outer = 'margin: 0 6px 0 2px';
			position.inner = 'margin: 0 6px 0 2px';
		} else if(length == 9){

			position.outer = 'margin: 0 7px 0 '+baseLeft;
			position.inner = 'margin: 0 9px 0 '+baseLeft;

		} else {
			position.outer = 'margin: 0 11px 0 '+baseLeft;
			position.inner = 'margin: 0 15px 0 '+baseLeft;
		}

	}

	return position;
}


/**
 * [setNumbers] based on number array and font object --
 * -- from bindings
 * @param {array} [numberArray] input numbers split into array
 * @param {object} [fontObject] object with font references
 */
function setNumbers(numberArray, fontObject){
	var $numbers = $('#Numbers'),
			$container = $('.my-custom-sports-chair__app'),
			team = $('head').find('.team-name').attr('content');

	$numbers.empty();
 

	for (var i = 0; i < numberArray.length; i++) {
		$.each(fontObject, function(key, value){
		  if (numberArray[i].toLowerCase() == key) {
		  	if (i == 0 && numberArray.length > 1 && team == 'vikings' && numberArray[i].toLowerCase() != '0') {
		  		$('#Numbers').append('<span class="'+ fontObject[key] +'_first custom-number"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span></span>');
		  	} else {
		  		$('#Numbers').append('<span class="'+ fontObject[key] +' custom-number"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span></span>');
		  	}
			}
		});
	}

	//adjust left css value to center numbers
	var numberWidth = $numbers.width();
	var parentWidth = $container.width();
	var leftValue = (parseInt(parentWidth - numberWidth)) / 2;
	$numbers.css('left', leftValue);
}

function letterValidate(input){
	var valid = false,
			regex = /^[a-zA-Z]+$/;

	if (input == '' && input.length == 0) {
		$('#Letters').empty();
	}

	if (regex.test(input) !== true) {
		valid = false;
		input.replace(regex, '');
		$('#custom-name').val(input);
	} else {
		valid = true;
	}
	return valid;
}

function numberValidate(input){
	var valid = false,
			regex = /^[0-9]+$/;

	if (input == '' && input.length == 0) {
		$('#Numbers').empty();
	}

	if (regex.test(input) !== true) {
		valid = false;
		input.replace(regex, '');
		$('#custom-number').val(input);
	} else {
		valid = true;
	}
	return valid;
}
//------------------bindings------------------//
/**
 * Letter input
 */
$('#custom-name').on('input', function(e){

	var valid = letterValidate($(this).val());

	if (valid) {
		//get letter field chars and split
		///get font object
		var letterArray = $(this).val().split(''),
				fontObject = generateFont();

		setLetters(letterArray, fontObject);
	} else {
		e.preventDefault();
	}
});

/**
 * Number input
 */
$('#custom-number').on('input', function(e){

	var valid = numberValidate($(this).val());

	if (valid) {
		//get number field chars and split
		//get font object
		var numberArray = $(this).val().split(''),
				fontObject = generateFont();

		setNumbers(numberArray, fontObject);
	} else {
		e.preventDefault();
	}
});


/**
 * home/away variant selection
 */
$('.home input, .away input, .retro input').on('click', function(){
	var customerNumber = $('#custom-number').val(),
			customerName = $('#custom-name').val(),
			numberArray = customerNumber.split(''),
			letterArray = customerName.split(''),
			fontObject = generateFont();
	
	setLetters(letterArray, fontObject);
	setNumbers(numberArray, fontObject);
});


/**
 * light/grey/dark variant selection
 */
$('.dark input, .light input, .grey input,.alternate input, .beige input, .powder input, .navy input, .orange input, .royal input, .extra input').on('click', function(){
	var customerNumber = $('#custom-number').val(),
			customerName = $('#custom-name').val(),
			numberArray = customerNumber.split(''),
			letterArray = customerName.split(''),
			fontObject = generateFont();
	
	setLetters(letterArray, fontObject);
	setNumbers(numberArray, fontObject);
  
  	/**
     * Handling Font Shifting for MLB products
     * This was required because for MLB we're using different font files for 
     * different variants with different width of letters/numbers 
     */
  	setTimeout(function() {
		$(window).trigger('resize');
	}, 5);
  	
});


/**
 * adjust char container positon on window resize
 */
$(window).on('resize', function(event) {
	var numberWidth = $('#Numbers').width(),
			letterWidth = $('#Letters').width(),
			parentWidth = $('.my-custom-sports-chair__app').width();

	var numberLeftValue = (parseInt(parentWidth - numberWidth)) / 2;
	var letterLeftValue = (parseInt(parentWidth - letterWidth - 3)) / 2;

	var $letters = $('#custom-name');
	var inputValues = $letters.val();
	var array = inputValues.split('');
	var font = generateFont();


	setLetters(array, font);

	$('#Numbers').css('left', numberLeftValue);
	$('#Letters').css('left', letterLeftValue);
});



/**
 * SHOW/HIDE add to cart for NFL products
 */
if ($('body').hasClass('product-nfl') ) {

	var splitUrl = window.location.href.split('/');
	var splitDomain = splitUrl[2].split('.');
	var domain = splitDomain[1];

	if (domain == 'com') {
		$('#addToCart').css('display', 'none');
		$('.desc_blk_bot').css('display', 'none');
		$('.price').css('display', 'none');
		$('#UnavailableMessage').css('display', 'block');
	} else {
		$('#addToCart').css('display', 'block');
		$('#UnavailableMessage').css('display', 'none');
	}
}



jQuery(document).ready(function($) {
	
  $('.hidden-lg.hidden-md .slick-prev, .hidden-lg.hidden-md .slick-next').on('click', function(){
    var numberWidth = $('#Numbers').width(),
			letterWidth = $('#Letters').width(),
			parentWidth = $('.my-custom-sports-chair__app').width();

	var numberLeftValue = (parseInt(parentWidth - numberWidth)) / 2;
	var letterLeftValue = (parseInt(parentWidth - letterWidth - 3)) / 2;
    
	var $letters = $('#custom-name');
	var inputValues = $letters.val();
	var array = inputValues.split('');
	var font = generateFont();


	setLetters(array, font);

	$('#Numbers').css('left', numberLeftValue);
	$('#Letters').css('left', letterLeftValue);
  });
});
